import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Plus, Edit, Trash2, Settings as SettingsIcon, Tag, Radio, Upload, X, Image as ImageIcon, Link as LinkIcon, Copy, Check, ExternalLink, ChevronUp, ChevronDown, Star, DollarSign, Calendar, Percent, Users, CreditCard, UserCog, Eye, EyeOff, Briefcase, Search, BarChart2, GitMerge, ArrowRightLeft, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { usePropiedad } from '../contexts/PropiedadContext';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Configuracion = () => {
  const navigate = useNavigate();
  const { propiedadSeleccionada, cambiarPropiedad, propiedades, cargarPropiedades } = usePropiedad();
  const { isAdmin } = useAuth();
  const [canales, setCanales] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [estadosReserva, setEstadosReserva] = useState([]);
  const [mediosPago, setMediosPago] = useState([]);
  const [estadosIngreso, setEstadosIngreso] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [todasLasPropiedades, setTodasLasPropiedades] = useState([]);
  const [modalPropAbierto, setModalPropAbierto] = useState(false);
  const [modalCanalAbierto, setModalCanalAbierto] = useState(false);
  const [modalCatAbierto, setModalCatAbierto] = useState(false);
  const [modalEstadoAbierto, setModalEstadoAbierto] = useState(false);
  const [modalEstadoIngresoAbierto, setModalEstadoIngresoAbierto] = useState(false);
  const [modalMedioPagoAbierto, setModalMedioPagoAbierto] = useState(false);
  const [modalUsuarioAbierto, setModalUsuarioAbierto] = useState(false);
  const [modalProvAbierto, setModalProvAbierto] = useState(false);
  const [modalFusionAbierto, setModalFusionAbierto] = useState(false);
  const [proveedorDestinoId, setProveedorDestinoId] = useState('');
  const [proveedorOrigenId, setProveedorOrigenId] = useState('');
  const [cargandoFusion, setCargandoFusion] = useState(false);
  const [filtroProveedor, setFiltroProveedor] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('todas');
  const [proveedoresExpandidos, setProveedoresExpandidos] = useState(new Set());
  const [datosGraficos, setDatosGraficos] = useState({});
  const [cargandoGraficos, setCargandoGraficos] = useState({});
  const [anioGrafico, setAnioGrafico] = useState(new Date().getFullYear().toString());
  
  const currentYearInt = new Date().getFullYear();
  const aniosDisponiblesGrafico = Array.from({ length: 6 }, (_, i) => (currentYearInt - 4 + i).toString());
  const [editando, setEditando] = useState(null);
  const [linkCopiado, setLinkCopiado] = useState(null);
  const [categoriaExpandida, setCategoriaExpandida] = useState(null);
  const [nuevoProveedor, setNuevoProveedor] = useState('');
  const [proveedorEditando, setProveedorEditando] = useState(null);
  const [nombreProveedorEdit, setNombreProveedorEdit] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);
  
  const [formProp, setFormProp] = useState({ 
    nombre: '', 
    ubicacion: '', 
    capacidad: '', 
    dormitorios: '', 
    dormitorios_descripciones: [],
    banos: '', 
    caracteristicas: '', 
    condiciones_pago: '', 
    fotos: [],
    foto_fondo_index: 0,
    tipo_arriendo: 'seasonal',
    precio_base_noche: 0,
    precio_mensual: 0,
    precios_personalizados: [],
    descuentos: [],
    otros_cobros: [],
    activo: true 
  });
  const [archivosPropiedad, setArchivosPropiedad] = useState([]);
  const [subiendoFotos, setSubiendoFotos] = useState(false);
  const [formCanal, setFormCanal] = useState({ nombre: '', color: '#1AA1D8' });
  const [formCat, setFormCat] = useState({ nombre: '', tipo: 'operacional', gasto_mensual_maximo: {} });
  const [modalPresupuestoAbierto, setModalPresupuestoAbierto] = useState(false);
  const [catPresupuesto, setCatPresupuesto] = useState(null);
  const [montoPresupuestoTemp, setMontoPresupuestoTemp] = useState('');
  const [tabActiva, setTabActiva] = useState('propiedades');
  const [formEstado, setFormEstado] = useState({ nombre: '', color: '#1AA1D8', color_texto: '#FFFFFF', orden: 0 });
  const [formEstadoIngreso, setFormEstadoIngreso] = useState({ nombre: '', color: '#1AA1D8', color_texto: '#FFFFFF', orden: 0 });
  const [formMedioPago, setFormMedioPago] = useState({ nombre: '', activo: true });
  const [formUsuario, setFormUsuario] = useState({ email: '', password: '', propiedades_asignadas: [], is_admin: false, activo: true });
  const [formProv, setFormProv] = useState({ nombre: '', categoria_id: '' });

  const formatCurrency = (value) => {
    return `$${Math.round(value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  useEffect(() => {
    // Cargar datos de la propiedad seleccionada
    if (propiedadSeleccionada) {
      setFormProp({
        nombre: propiedadSeleccionada.nombre || '', 
        ubicacion: propiedadSeleccionada.ubicacion || '',
        capacidad: propiedadSeleccionada.capacidad || '',
        dormitorios: propiedadSeleccionada.dormitorios || '',
        dormitorios_descripciones: propiedadSeleccionada.dormitorios_descripciones || [],
        banos: propiedadSeleccionada.banos || '',
        caracteristicas: propiedadSeleccionada.caracteristicas || '',
        condiciones_pago: propiedadSeleccionada.condiciones_pago || '',
        fotos: propiedadSeleccionada.fotos || [],
        foto_fondo_index: propiedadSeleccionada.foto_fondo_index || 0,
        tipo_arriendo: propiedadSeleccionada.tipo_arriendo || 'seasonal',
        precio_base_noche: propiedadSeleccionada.precio_base_noche || 0,
        precio_mensual: propiedadSeleccionada.precio_mensual || 0,
        precios_personalizados: propiedadSeleccionada.precios_personalizados || [],
        descuentos: propiedadSeleccionada.descuentos || [],
        otros_cobros: propiedadSeleccionada.otros_cobros || [],
        activo: propiedadSeleccionada.activo !== false
      });
    }
  }, [propiedadSeleccionada]);

  const cargarDatos = async () => {
    try {
      const [resCanales, resCat, resProv, resEstados, resMediosPago, resPropiedades, resEstadosIngreso] = await Promise.all([
        axios.get(`${API}/canales`),
        axios.get(`${API}/categorias`),
        axios.get(`${API}/proveedores`),
        axios.get(`${API}/estados-reserva`),
        axios.get(`${API}/medios-pago`),
        axios.get(`${API}/propiedades`),
        axios.get(`${API}/estados-ingreso`)
      ]);
      setCanales(resCanales.data);
      setCategorias(resCat.data);
      setProveedores(resProv.data);
      setEstadosReserva(resEstados.data);
      setMediosPago(resMediosPago.data);
      setTodasLasPropiedades(resPropiedades.data);
      setEstadosIngreso(resEstadosIngreso.data);
      
      // Cargar usuarios solo si es admin
      if (isAdmin()) {
        try {
          const resUsuarios = await axios.get(`${API}/usuarios`);
          setUsuarios(resUsuarios.data);
        } catch (error) {
          console.log('No se pudieron cargar usuarios');
        }
      }
    } catch (error) {
      toast.error('Error al cargar datos');
    }
  };

  // ===== PROVEEDORES =====
  const proveedoresPorCategoria = (categoriaId) => {
    return proveedores.filter(p => p.categoria_id === categoriaId);
  };

  const agregarProveedor = async (categoriaId) => {
    if (!nuevoProveedor.trim()) {
      toast.error('Ingresa un nombre para el proveedor');
      return;
    }

    try {
      const response = await axios.post(`${API}/proveedores`, {
        nombre: nuevoProveedor.trim(),
        categoria_id: categoriaId
      });
      setProveedores([...proveedores, response.data]);
      setNuevoProveedor('');
      toast.success('Proveedor agregado');
    } catch (error) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Error al agregar proveedor');
      }
    }
  };

  const eliminarProveedor = async (idProveedor) => {
    try {
      await axios.delete(`${API}/proveedores/${idProveedor}`);
      setProveedores(proveedores.filter(p => p.id_proveedor !== idProveedor));
      toast.success('Proveedor eliminado');
    } catch (error) {
      toast.error('Error al eliminar proveedor');
    }
  };

  const iniciarEdicionProveedor = (proveedor) => {
    setProveedorEditando(proveedor.id_proveedor);
    setNombreProveedorEdit(proveedor.nombre);
  };

  const cancelarEdicionProveedor = () => {
    setProveedorEditando(null);
    setNombreProveedorEdit('');
  };

  const guardarEdicionProveedor = async (idProveedor) => {
    if (!nombreProveedorEdit.trim()) {
      toast.error('El nombre no puede estar vacío');
      return;
    }

    // Obtener el proveedor actual para mantener su categoria_id
    const proveedorActual = proveedores.find(p => p.id_proveedor === idProveedor);
    if (!proveedorActual) {
      toast.error('Proveedor no encontrado');
      return;
    }

    try {
      await axios.put(`${API}/proveedores/${idProveedor}`, {
        nombre: nombreProveedorEdit.trim(),
        categoria_id: proveedorActual.categoria_id
      });
      setProveedores(proveedores.map(p => 
        p.id_proveedor === idProveedor 
          ? { ...p, nombre: nombreProveedorEdit.trim() }
          : p
      ));
      setProveedorEditando(null);
      setNombreProveedorEdit('');
      toast.success('Proveedor actualizado');
    } catch (error) {
      toast.error('Error al actualizar proveedor');
    }
  };

  const cargarDatosGrafico = async (prov, year) => {
    const provId = prov.id_proveedor;
    setCargandoGraficos(prev => ({ ...prev, [provId]: true }));
    setDatosGraficos(prev => ({ ...prev, [provId]: { data: [], propiedades: [] } }));
    
    try {
      const response = await axios.get(`${API}/gastos?proveedor_id=${prov.id_proveedor}&year=${year}`);
      
      // Strict frontend filter to ensure we only show this provider's expenses
      const gastosDelProveedor = response.data.filter(g => 
        (g.proveedor_id && g.proveedor_id === prov.id_proveedor) || 
        (g.proveedor && g.proveedor.toLowerCase() === prov.nombre.toLowerCase())
      );
      
      const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      const gastosPorMes = {};
      
      meses.forEach(mes => {
        gastosPorMes[mes] = { name: mes };
      });
      
      const propiedadesInvolucradas = new Set();
      
      gastosDelProveedor.forEach(gasto => {
        const propId = gasto.propiedad_id;
        const nombreProp = obtenerNombrePropiedad(propId);
        propiedadesInvolucradas.add(nombreProp);
        
        if (gasto.fecha) {
          const [yearStr, monthStr] = gasto.fecha.split('-');
          if (monthStr) {
            const mesIndex = parseInt(monthStr, 10) - 1;
            if (mesIndex >= 0 && mesIndex < 12) {
              const mesNombre = meses[mesIndex];
              if (!gastosPorMes[mesNombre][nombreProp]) {
                gastosPorMes[mesNombre][nombreProp] = 0;
              }
              gastosPorMes[mesNombre][nombreProp] += (gasto.monto || 0);
            }
          }
        }
      });
      
      setDatosGraficos(prev => ({
        ...prev,
        [provId]: {
          data: Object.values(gastosPorMes),
          propiedades: Array.from(propiedadesInvolucradas)
        }
      }));
    } catch (error) {
      console.error('Error fetching expenses for provider', error);
      toast.error(`Error al cargar datos del gráfico para ${prov.nombre}`);
    } finally {
      setCargandoGraficos(prev => ({ ...prev, [provId]: false }));
    }
  };

  const cambiarAnioGrafico = async (year) => {
    setAnioGrafico(year);
    const promises = Array.from(proveedoresExpandidos).map(provId => {
      const prov = proveedores.find(p => p.id_proveedor === provId);
      if (prov) return cargarDatosGrafico(prov, year);
      return Promise.resolve();
    });
    await Promise.all(promises);
  };

  const toggleProveedorGrafico = async (prov) => {
    const provId = prov.id_proveedor;
    setProveedoresExpandidos(prev => {
      const next = new Set(prev);
      if (next.has(provId)) {
        next.delete(provId);
      } else {
        next.add(provId);
      }
      return next;
    });
    
    setProveedoresExpandidos(prev => {
      if (prev.has(provId)) {
        cargarDatosGrafico(prov, anioGrafico);
      }
      return prev;
    });
  };

  const toggleTodosLosGraficos = async () => {
    const provsVisibles = proveedores.filter(prov => {
      const matchSearch = prov.nombre?.toLowerCase().includes(filtroProveedor.toLowerCase());
      const matchCat = filtroCategoria === 'todas' || prov.categoria_id === parseInt(filtroCategoria);
      return matchSearch && matchCat;
    });
    
    const todosVisiblesExpandidos = provsVisibles.every(p => proveedoresExpandidos.has(p.id_proveedor));
    
    if (todosVisiblesExpandidos) {
      setProveedoresExpandidos(prev => {
        const next = new Set(prev);
        provsVisibles.forEach(p => next.delete(p.id_proveedor));
        return next;
      });
    } else {
      const nextExpandidos = new Set(proveedoresExpandidos);
      const promises = [];
      
      provsVisibles.forEach(prov => {
        if (!nextExpandidos.has(prov.id_proveedor)) {
          nextExpandidos.add(prov.id_proveedor);
          promises.push(cargarDatosGrafico(prov, anioGrafico));
        }
      });
      
      setProveedoresExpandidos(nextExpandidos);
      await Promise.all(promises);
    }
  };

  const abrirModalProv = (prov = null) => {
    if (prov) {
      setEditando(prov);
      setFormProv({ nombre: prov.nombre, categoria_id: prov.categoria_id });
    } else {
      setEditando(null);
      setFormProv({ nombre: '', categoria_id: categorias.length > 0 ? categorias[0].id_categoria : '' });
    }
    setModalProvAbierto(true);
  };

  const guardarProveedorModal = async () => {
    if (!formProv.nombre.trim()) {
      toast.error('El nombre del proveedor es obligatorio');
      return;
    }
    if (!formProv.categoria_id) {
      toast.error('Debe seleccionar una categoría');
      return;
    }
    try {
      if (editando) {
        await axios.put(`${API}/proveedores/${editando.id_proveedor}`, formProv);
        toast.success('Proveedor actualizado');
      } else {
        await axios.post(`${API}/proveedores`, formProv);
        toast.success('Proveedor creado');
      }
      cargarDatos();
      setModalProvAbierto(false);
    } catch (error) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Error al guardar proveedor');
      }
    }
  };

  // ===== FUSIÓN DE PROVEEDORES =====
  const abrirModalFusion = (provInicial = null) => {
    if (provInicial) {
      // Pre-seleccionamos el proveedor cliqueado como duplicado a fusionar (origen)
      setProveedorOrigenId(provInicial.id_proveedor);
      setProveedorDestinoId('');
    } else {
      setProveedorDestinoId('');
      setProveedorOrigenId('');
    }
    setModalFusionAbierto(true);
  };

  const intercambiarSeleccionFusion = () => {
    const tempDestino = proveedorDestinoId;
    setProveedorDestinoId(proveedorOrigenId);
    setProveedorOrigenId(tempDestino);
  };

  const ejecutarFusionProveedores = async () => {
    if (!proveedorDestinoId) {
      toast.error('Selecciona el proveedor principal a conservar');
      return;
    }
    if (!proveedorOrigenId) {
      toast.error('Selecciona el proveedor duplicado que deseas fusionar');
      return;
    }
    if (proveedorDestinoId === proveedorOrigenId) {
      toast.error('El proveedor destino y origen no pueden ser el mismo');
      return;
    }

    const provDestino = proveedores.find(p => p.id_proveedor === proveedorDestinoId);
    const provOrigen = proveedores.find(p => p.id_proveedor === proveedorOrigenId);

    const confirmar = window.confirm(
      `¿Confirmas la fusión del proveedor "${provOrigen?.nombre || 'Duplicado'}" en "${provDestino?.nombre || 'Principal'}"?\n\n` +
      `• Todos los gastos y registros asociados serán reasignados a "${provDestino?.nombre}".\n` +
      `• El proveedor duplicado "${provOrigen?.nombre}" será eliminado definitivamente.\n` +
      `• Las categorías asociadas serán consolidadas en el proveedor principal.`
    );
    if (!confirmar) return;

    setCargandoFusion(true);
    try {
      const response = await axios.post(`${API}/proveedores/fusionar`, {
        id_proveedor_destino: proveedorDestinoId,
        id_proveedor_origen: proveedorOrigenId
      });

      const { gastos_actualizados, gastos_recurrentes_actualizados, message } = response.data;
      toast.success(message || 'Proveedores fusionados exitosamente', {
        description: `Se reasignaron ${gastos_actualizados || 0} gastos y ${gastos_recurrentes_actualizados || 0} recurrentes.`
      });

      setModalFusionAbierto(false);
      setProveedorDestinoId('');
      setProveedorOrigenId('');
      cargarDatos();
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Error al fusionar proveedores';
      toast.error(errorMsg);
    } finally {
      setCargandoFusion(false);
    }
  };

  // ===== PROPIEDADES =====
  const abrirModalProp = (prop = null) => {
    if (prop) {
      setEditando(prop);
      setFormProp({ 
        nombre: prop.nombre, 
        ubicacion: prop.ubicacion,
        capacidad: prop.capacidad || '',
        dormitorios: prop.dormitorios || '',
        dormitorios_descripciones: prop.dormitorios_descripciones || [],
        banos: prop.banos || '',
        caracteristicas: prop.caracteristicas || '',
        condiciones_pago: prop.condiciones_pago || '',
        fotos: prop.fotos || [],
        foto_fondo_index: prop.foto_fondo_index || 0,
        tipo_arriendo: prop.tipo_arriendo || 'seasonal',
        precio_base_noche: prop.precio_base_noche || 0,
        precio_mensual: prop.precio_mensual || 0,
        precios_personalizados: prop.precios_personalizados || [],
        descuentos: prop.descuentos || [],
        otros_cobros: prop.otros_cobros || [],
        activo: prop.activo 
      });
    } else {
      setEditando(null);
      setFormProp({ 
        nombre: '', 
        ubicacion: '', 
        capacidad: '', 
        dormitorios: '', 
        dormitorios_descripciones: [],
        banos: '', 
        caracteristicas: '', 
        condiciones_pago: '', 
        fotos: [],
        foto_fondo_index: 0,
        tipo_arriendo: 'seasonal',
        precio_base_noche: 0,
        precio_mensual: 0,
        precios_personalizados: [],
        descuentos: [],
        otros_cobros: [],
        activo: true 
      });
    }
    setArchivosPropiedad([]);
    setModalPropAbierto(true);
  };

  const subirFotosPropiedad = async () => {
    if (archivosPropiedad.length === 0) return [];
    
    try {
      setSubiendoFotos(true);
      const formData = new FormData();
      archivosPropiedad.forEach(file => {
        formData.append('files', file);
      });
      
      const response = await axios.post(`${API}/upload-fotos-propiedad`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      setSubiendoFotos(false);
      return response.data.urls;
    } catch (error) {
      setSubiendoFotos(false);
      toast.error('Error al subir fotos');
      return [];
    }
  };

  const guardarPropiedad = async () => {
    try {
      // Subir fotos nuevas si las hay
      let fotosUrls = [...formProp.fotos];
      if (archivosPropiedad.length > 0) {
        const nuevasUrls = await subirFotosPropiedad();
        fotosUrls = [...fotosUrls, ...nuevasUrls];
      }

      const datosPropiedad = {
        ...formProp,
        capacidad: formProp.capacidad ? parseInt(formProp.capacidad) : null,
        dormitorios: formProp.dormitorios ? parseInt(formProp.dormitorios) : null,
        banos: formProp.banos ? parseInt(formProp.banos) : null,
        fotos: fotosUrls
      };

      if (editando) {
        await axios.put(`${API}/propiedades/${editando.id_propiedad}`, datosPropiedad);
        toast.success('Propiedad actualizada');
      } else {
        await axios.post(`${API}/propiedades`, datosPropiedad);
        toast.success('Propiedad creada');
      }
      await cargarPropiedades(); // Recargar contexto
      cargarDatos();
      setModalPropAbierto(false);
    } catch (error) {
      toast.error('Error al guardar');
    }
  };

  const eliminarPropiedad = async (id) => {
    try {
      await axios.delete(`${API}/propiedades/${id}`);
      toast.success('Propiedad eliminada');
      await cargarPropiedades(); // Recargar contexto
      cargarDatos();
    } catch (error) {
      toast.error('Error al eliminar');
    }
  };

  // Manejar cambios en el número de dormitorios
  const handleDormitoriosChange = (num) => {
    const numDormitorios = parseInt(num) || 0;
    setFormProp(prev => {
      const descripciones = [];
      for (let i = 1; i <= numDormitorios; i++) {
        const existing = prev.dormitorios_descripciones.find(d => d.numero === i);
        descripciones.push(existing || { numero: i, descripcion: '' });
      }
      return { ...prev, dormitorios: num, dormitorios_descripciones: descripciones };
    });
  };

  const updateDormitorioDescripcion = (numero, descripcion) => {
    setFormProp(prev => ({
      ...prev,
      dormitorios_descripciones: prev.dormitorios_descripciones.map(d =>
        d.numero === numero ? { ...d, descripcion } : d
      )
    }));
  };

  const eliminarFoto = (index) => {
    setFormProp(prev => {
      const newFotos = prev.fotos.filter((_, i) => i !== index);
      let newFondoIndex = prev.foto_fondo_index;
      
      // Ajustar índice de fondo si es necesario
      if (index === prev.foto_fondo_index) {
        // Si eliminamos la foto de fondo, usar la primera
        newFondoIndex = 0;
      } else if (index < prev.foto_fondo_index) {
        // Si eliminamos una foto antes del fondo, decrementar índice
        newFondoIndex = prev.foto_fondo_index - 1;
      }
      
      return {
        ...prev,
        fotos: newFotos,
        foto_fondo_index: Math.max(0, Math.min(newFondoIndex, newFotos.length - 1))
      };
    });
  };


  const moverFotoArriba = (index) => {
    if (index === 0) return; // Ya está al principio
    setFormProp(prev => {
      const newFotos = [...prev.fotos];
      [newFotos[index - 1], newFotos[index]] = [newFotos[index], newFotos[index - 1]];
      
      // Ajustar índice de fondo si es necesario
      let newFondoIndex = prev.foto_fondo_index;
      if (prev.foto_fondo_index === index) {
        newFondoIndex = index - 1;
      } else if (prev.foto_fondo_index === index - 1) {
        newFondoIndex = index;
      }
      
      return { ...prev, fotos: newFotos, foto_fondo_index: newFondoIndex };
    });
    toast.success('Foto movida');
  };

  const moverFotoAbajo = (index) => {
    setFormProp(prev => {
      if (index === prev.fotos.length - 1) return prev; // Ya está al final
      const newFotos = [...prev.fotos];
      [newFotos[index], newFotos[index + 1]] = [newFotos[index + 1], newFotos[index]];
      
      // Ajustar índice de fondo si es necesario
      let newFondoIndex = prev.foto_fondo_index;
      if (prev.foto_fondo_index === index) {
        newFondoIndex = index + 1;
      } else if (prev.foto_fondo_index === index + 1) {
        newFondoIndex = index;
      }
      
      return { ...prev, fotos: newFotos, foto_fondo_index: newFondoIndex };
    });
    toast.success('Foto movida');
  };


  const copiarLinkPropiedad = async (propiedadId) => {
    const url = `${window.location.origin}${process.env.PUBLIC_URL || ''}/`;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      
      setLinkCopiado(propiedadId);
      toast.success('¡Link copiado al portapapeles!');
      
      setTimeout(() => {
        setLinkCopiado(null);
      }, 2000);
    } catch (error) {
      console.error('Error al copiar:', error);
      toast.info(`Link: ${url}`, { duration: 5000 });
    }
  };

  // ===== CANALES =====
  const abrirModalCanal = (canal = null) => {
    if (canal) {
      setEditando(canal);
      setFormCanal({ nombre: canal.nombre, color: canal.color });
    } else {
      setEditando(null);
      setFormCanal({ nombre: '', color: '#1AA1D8' });
    }
    setModalCanalAbierto(true);
  };

  const guardarCanal = async () => {
    try {
      if (editando) {
        await axios.put(`${API}/canales/${editando.id_canal}`, formCanal);
        toast.success('Canal actualizado');
      } else {
        await axios.post(`${API}/canales`, formCanal);
        toast.success('Canal creado');
      }
      cargarDatos();
      setModalCanalAbierto(false);
    } catch (error) {
      toast.error('Error al guardar');
    }
  };

  const eliminarCanal = async (id) => {
    if (window.confirm('¿Eliminar este canal?')) {
      try {
        await axios.delete(`${API}/canales/${id}`);
        toast.success('Canal eliminado');
        cargarDatos();
      } catch (error) {
        toast.error('Error al eliminar');
      }
    }
  };

  // ===== ESTADOS DE RESERVA =====
  const abrirModalEstado = (estado = null) => {
    if (estado) {
      setEditando(estado);
      setFormEstado({ 
        nombre: estado.nombre, 
        color: estado.color, 
        color_texto: estado.color_texto || '#FFFFFF',
        orden: estado.orden || 0 
      });
    } else {
      setEditando(null);
      const maxOrden = estadosReserva.reduce((max, e) => Math.max(max, e.orden || 0), 0);
      setFormEstado({ nombre: '', color: '#1AA1D8', color_texto: '#FFFFFF', orden: maxOrden + 1 });
    }
    setModalEstadoAbierto(true);
  };

  const guardarEstado = async () => {
    if (!formEstado.nombre.trim()) {
      toast.error('El nombre del estado es obligatorio');
      return;
    }
    try {
      if (editando) {
        await axios.put(`${API}/estados-reserva/${editando.id_estado}`, formEstado);
        toast.success('Estado actualizado');
      } else {
        await axios.post(`${API}/estados-reserva`, formEstado);
        toast.success('Estado creado');
      }
      cargarDatos();
      setModalEstadoAbierto(false);
    } catch (error) {
      toast.error('Error al guardar');
    }
  };

  const eliminarEstado = async (id) => {
    if (window.confirm('¿Eliminar este estado? Las reservas con este estado podrían verse afectadas.')) {
      try {
        await axios.delete(`${API}/estados-reserva/${id}`);
        toast.success('Estado eliminado');
        cargarDatos();
      } catch (error) {
        toast.error('Error al eliminar');
      }
    }
  };

  // ===== ESTADOS DE INGRESO =====
  const abrirModalEstadoIngreso = (estado = null) => {
    if (estado) {
      setEditando(estado);
      setFormEstadoIngreso({ 
        nombre: estado.nombre, 
        color: estado.color, 
        color_texto: estado.color_texto || '#FFFFFF',
        orden: estado.orden || 0 
      });
    } else {
      setEditando(null);
      const maxOrden = estadosIngreso.reduce((max, e) => Math.max(max, e.orden || 0), 0);
      setFormEstadoIngreso({ nombre: '', color: '#1AA1D8', color_texto: '#FFFFFF', orden: maxOrden + 1 });
    }
    setModalEstadoIngresoAbierto(true);
  };

  const guardarEstadoIngreso = async () => {
    if (!formEstadoIngreso.nombre.trim()) {
      toast.error('El nombre del estado es obligatorio');
      return;
    }
    try {
      if (editando) {
        await axios.put(`${API}/estados-ingreso/${editando.id_estado}`, formEstadoIngreso);
        toast.success('Estado de ingreso actualizado');
      } else {
        await axios.post(`${API}/estados-ingreso`, formEstadoIngreso);
        toast.success('Estado de ingreso creado');
      }
      cargarDatos();
      setModalEstadoIngresoAbierto(false);
    } catch (error) {
      toast.error('Error al guardar');
    }
  };

  const eliminarEstadoIngreso = async (id) => {
    if (window.confirm('¿Eliminar este estado? Los ingresos con este estado podrían verse afectados.')) {
      try {
        await axios.delete(`${API}/estados-ingreso/${id}`);
        toast.success('Estado de ingreso eliminado');
        cargarDatos();
      } catch (error) {
        toast.error('Error al eliminar');
      }
    }
  };

  // ===== CATEGORIAS =====
  const abrirModalCat = (cat = null) => {
    if (cat) {
      setEditando(cat);
      setFormCat({
        nombre: cat.nombre,
        tipo: cat.tipo,
        gasto_mensual_maximo: { ...(cat.gasto_mensual_maximo || {}) }
      });
    } else {
      setEditando(null);
      setFormCat({
        nombre: '',
        tipo: 'operacional',
        gasto_mensual_maximo: {}
      });
    }
    setModalCatAbierto(true);
  };

  const abrirModalPresupuesto = (cat) => {
    setCatPresupuesto(cat);
    const actual = (cat.gasto_mensual_maximo || {})[propiedadSeleccionada?.id_propiedad] || 0;
    setMontoPresupuestoTemp(actual > 0 ? actual.toString() : '');
    setModalPresupuestoAbierto(true);
  };

  const guardarPresupuestoPropiedad = async () => {
    if (!catPresupuesto || !propiedadSeleccionada) return;
    try {
      const monto = parseFloat(montoPresupuestoTemp) || 0;
      await axios.patch(`${API}/categorias/${catPresupuesto.id_categoria}/presupuesto`, {
        propiedad_id: propiedadSeleccionada.id_propiedad,
        monto_maximo: monto
      });
      toast.success(`Límite mensual de "${catPresupuesto.nombre}" actualizado para ${propiedadSeleccionada.nombre}`);
      setModalPresupuestoAbierto(false);
      cargarDatos();
    } catch (error) {
      toast.error('Error al actualizar el límite mensual');
    }
  };

  const guardarCategoria = async () => {
    try {
      if (editando) {
        await axios.put(`${API}/categorias/${editando.id_categoria}`, formCat);
        toast.success('Categoría actualizada');
      } else {
        await axios.post(`${API}/categorias`, formCat);
        toast.success('Categoría creada');
      }
      cargarDatos();
      setModalCatAbierto(false);
    } catch (error) {
      toast.error('Error al guardar');
    }
  };

  const eliminarCategoria = async (id) => {
    if (window.confirm('¿Eliminar esta categoría?')) {
      try {
        await axios.delete(`${API}/categorias/${id}`);
        toast.success('Categoría eliminada');
        cargarDatos();
      } catch (error) {
        toast.error('Error al eliminar');
      }
    }
  };

  // ===== MEDIOS DE PAGO =====
  const abrirModalMedioPago = (medio = null) => {
    if (medio) {
      setEditando(medio);
      setFormMedioPago({ nombre: medio.nombre, activo: medio.activo !== false });
    } else {
      setEditando(null);
      setFormMedioPago({ nombre: '', activo: true });
    }
    setModalMedioPagoAbierto(true);
  };

  const guardarMedioPago = async () => {
    if (!formMedioPago.nombre.trim()) {
      toast.error('El nombre del medio de pago es obligatorio');
      return;
    }
    try {
      if (editando) {
        await axios.put(`${API}/medios-pago/${editando.id_medio_pago}`, formMedioPago);
        toast.success('Medio de pago actualizado');
      } else {
        await axios.post(`${API}/medios-pago`, formMedioPago);
        toast.success('Medio de pago creado');
      }
      cargarDatos();
      setModalMedioPagoAbierto(false);
    } catch (error) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Error al guardar');
      }
    }
  };

  const eliminarMedioPago = async (id) => {
    if (window.confirm('¿Eliminar este medio de pago?')) {
      try {
        await axios.delete(`${API}/medios-pago/${id}`);
        toast.success('Medio de pago eliminado');
        cargarDatos();
      } catch (error) {
        toast.error('Error al eliminar');
      }
    }
  };

  // ===== USUARIOS =====
  const abrirModalUsuario = (usuario = null) => {
    if (usuario) {
      setEditando(usuario);
      setFormUsuario({ 
        email: usuario.email, 
        password: '', 
        propiedades_asignadas: usuario.propiedades_asignadas || [],
        is_admin: usuario.is_admin || false,
        activo: usuario.activo !== false
      });
    } else {
      setEditando(null);
      setFormUsuario({ email: '', password: '', propiedades_asignadas: [], is_admin: false, activo: true });
    }
    setMostrarPassword(false);
    setModalUsuarioAbierto(true);
  };

  const guardarUsuario = async () => {
    if (!formUsuario.email.trim()) {
      toast.error('El email es obligatorio');
      return;
    }
    if (!editando && !formUsuario.password) {
      toast.error('La contraseña es obligatoria para nuevos usuarios');
      return;
    }
    
    try {
      if (editando) {
        const updateData = {
          email: formUsuario.email,
          propiedades_asignadas: formUsuario.propiedades_asignadas,
          is_admin: formUsuario.is_admin,
          activo: formUsuario.activo
        };
        if (formUsuario.password) {
          updateData.password = formUsuario.password;
        }
        await axios.put(`${API}/usuarios/${editando.id_usuario}`, updateData);
        toast.success('Usuario actualizado');
      } else {
        await axios.post(`${API}/usuarios`, formUsuario);
        toast.success('Usuario creado');
      }
      cargarDatos();
      setModalUsuarioAbierto(false);
    } catch (error) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Error al guardar usuario');
      }
    }
  };

  const eliminarUsuario = async (id) => {
    if (window.confirm('¿Eliminar este usuario?')) {
      try {
        await axios.delete(`${API}/usuarios/${id}`);
        toast.success('Usuario eliminado');
        cargarDatos();
      } catch (error) {
        if (error.response?.data?.detail) {
          toast.error(error.response.data.detail);
        } else {
          toast.error('Error al eliminar usuario');
        }
      }
    }
  };

  const togglePropiedadAsignada = (propiedadId) => {
    setFormUsuario(prev => {
      const asignadas = prev.propiedades_asignadas || [];
      if (asignadas.includes(propiedadId)) {
        return { ...prev, propiedades_asignadas: asignadas.filter(id => id !== propiedadId) };
      } else {
        return { ...prev, propiedades_asignadas: [...asignadas, propiedadId] };
      }
    });
  };

  const obtenerNombrePropiedad = (id) => {
    const prop = todasLasPropiedades.find(p => p.id_propiedad === id);
    return prop ? prop.nombre : id;
  };

  const totalGastoMaximoEstimado = categorias.reduce((sum, cat) => {
    const val = (cat.gasto_mensual_maximo || {})[propiedadSeleccionada?.id_propiedad] || 0;
    return sum + (typeof val === 'number' ? val : parseFloat(val) || 0);
  }, 0);

  return (
    <div className="space-y-6 fade-in-up">
      <div>
        <h1 className="text-4xl font-bold text-[#0E3A53] mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Configuración
        </h1>
        <p className="text-[#0E3A53]/70">Administra propiedades, canales, categorías{isAdmin() ? ', usuarios' : ''} y medios de pago</p>
      </div>

      <Tabs value={tabActiva} onValueChange={setTabActiva} className="w-full">
        {/* Selector desplegable en móviles para acceso directo e inmediato a cualquier pestaña */}
        <div className="md:hidden mb-4">
          <label className="block text-xs font-semibold text-[#0E3A53]/70 mb-1.5 uppercase tracking-wider">
            Sección de Configuración
          </label>
          <div className="relative">
            <select
              value={tabActiva}
              onChange={(e) => setTabActiva(e.target.value)}
              className="w-full appearance-none bg-white border-2 border-[#8FE0FF]/80 rounded-xl px-4 py-3 text-sm font-bold text-[#0E3A53] shadow-md focus:outline-none focus:ring-2 focus:ring-[#1AA1D8] pr-10"
            >
              <option value="propiedades">⚙️ Propiedades</option>
              <option value="canales">📻 Canales</option>
              <option value="estados">📅 Estados Reserva</option>
              <option value="estados-ingreso">💵 Estados Ingreso</option>
              <option value="categorias">🏷️ Categorías</option>
              <option value="proveedores">💼 Proveedores</option>
              <option value="medios-pago">💳 Medios de Pago</option>
              {isAdmin() && <option value="usuarios">👤 Usuarios</option>}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3.5 text-[#1AA1D8]">
              <ChevronDown className="w-5 h-5 stroke-[2.5]" />
            </div>
          </div>
        </div>

        {/* Barra de pestañas responsiva: en móvil es un carrusel deslizable con scroll suave; en desktop una cuadrícula completa */}
        <div className="w-full overflow-x-auto no-scrollbar pb-1 mb-6 -mx-1 px-1">
          <TabsList className={`inline-flex md:grid w-max md:w-full min-w-full md:min-w-0 ${isAdmin() ? 'md:grid-cols-8' : 'md:grid-cols-7'} h-auto p-1.5 bg-white shadow-lg rounded-xl gap-1.5`}>
            <TabsTrigger value="propiedades" data-testid="tab-propiedades" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <SettingsIcon className="w-4 h-4 mr-1.5 shrink-0" />
              Propiedades
            </TabsTrigger>
            <TabsTrigger value="canales" data-testid="tab-canales" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <Radio className="w-4 h-4 mr-1.5 shrink-0" />
              Canales
            </TabsTrigger>
            <TabsTrigger value="estados" data-testid="tab-estados" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <Calendar className="w-4 h-4 mr-1.5 shrink-0" />
              Estados Reserva
            </TabsTrigger>
            <TabsTrigger value="estados-ingreso" data-testid="tab-estados-ingreso" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <DollarSign className="w-4 h-4 mr-1.5 shrink-0" />
              Estados Ingreso
            </TabsTrigger>
            <TabsTrigger value="categorias" data-testid="tab-categorias" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <Tag className="w-4 h-4 mr-1.5 shrink-0" />
              Categorías
            </TabsTrigger>
            <TabsTrigger value="proveedores" data-testid="tab-proveedores" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <Briefcase className="w-4 h-4 mr-1.5 shrink-0" />
              Proveedores
            </TabsTrigger>
            <TabsTrigger value="medios-pago" data-testid="tab-medios-pago" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
              <CreditCard className="w-4 h-4 mr-1.5 shrink-0" />
              Medios de Pago
            </TabsTrigger>
            {isAdmin() && (
              <TabsTrigger value="usuarios" data-testid="tab-usuarios" className="shrink-0 whitespace-nowrap px-3.5 py-2 text-xs sm:text-sm font-semibold rounded-lg data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#1AA1D8] data-[state=active]:to-[#0E3A53] data-[state=active]:text-white transition-all">
                <UserCog className="w-4 h-4 mr-1.5 shrink-0" />
                Usuarios
              </TabsTrigger>
            )}
          </TabsList>
        </div>


        {/* PROPIEDADES */}
        <TabsContent value="propiedades">
          <div className="card-beach">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Propiedades</h2>
              <Button 
                data-testid="add-propiedad-btn"
                onClick={() => abrirModalProp()}
                className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
              >
                <Plus className="w-5 h-5 mr-2" />
                Nueva Propiedad
              </Button>
            </div>
            <div className="space-y-3">
              {propiedades.map(prop => (
                <div key={prop.id_propiedad} className="bg-[#8FE0FF]/10 rounded-xl hover:bg-[#8FE0FF]/20 transition-colors p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <p className="font-semibold text-[#0E3A53]">{prop.nombre}</p>
                      <p className="text-sm text-[#0E3A53]/70">{prop.ubicacion}</p>
                    </div>
                    <div className="flex gap-2">
                      <button
                        data-testid={`edit-prop-${prop.id_propiedad}`}
                        onClick={() => abrirModalProp(prop)}
                        className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                        title="Editar"
                      >
                        <Edit className="w-4 h-4 text-[#1AA1D8]" />
                      </button>
                      <button
                        data-testid={`delete-prop-${prop.id_propiedad}`}
                        onClick={() => eliminarPropiedad(prop.id_propiedad)}
                        className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                        title="Eliminar"
                      >
                        <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                      </button>
                    </div>
                  </div>
                  
                  {/* Link de Fan Page (Solo para Depto Morrillos) */}
                  {prop.nombre?.toLowerCase().includes('morrillo') && (
                    <div className="flex gap-2 mt-4">
                      <a
                        href={`${window.location.origin}${process.env.PUBLIC_URL || ''}/`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-gradient-to-r from-cyan-600 to-cyan-700 text-white rounded-lg hover:from-cyan-700 hover:to-cyan-800 transition-all text-sm font-medium"
                      >
                        <ExternalLink className="w-4 h-4" />
                        Ver Fan Page
                      </a>
                      <button
                        onClick={() => copiarLinkPropiedad(prop.id_propiedad)}
                        className="px-4 py-2 bg-white border-2 border-cyan-600 text-cyan-600 rounded-lg hover:bg-cyan-50 transition-all text-sm font-medium flex items-center gap-2"
                        title="Copiar link"
                      >
                        {linkCopiado === prop.id_propiedad ? (
                          <>
                            <Check className="w-4 h-4" />
                            <span className="hidden sm:inline">Copiado</span>
                          </>
                        ) : (
                          <>
                            <Copy className="w-4 h-4" />
                            <span className="hidden sm:inline">Copiar Link</span>
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </TabsContent>

        {/* CANALES */}
        <TabsContent value="canales">
          <div className="card-beach">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Canales de Arriendo</h2>
              <Button 
                data-testid="add-canal-btn"
                onClick={() => abrirModalCanal()}
                className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
              >
                <Plus className="w-5 h-5 mr-2" />
                Nuevo Canal
              </Button>
            </div>
            <div className="space-y-3">
              {canales.map(canal => (
                <div key={canal.id_canal} className="flex items-center justify-between p-4 bg-[#8FE0FF]/10 rounded-xl hover:bg-[#8FE0FF]/20 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg" style={{ backgroundColor: canal.color }}></div>
                    <p className="font-semibold text-[#0E3A53]">{canal.nombre}</p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      data-testid={`edit-canal-${canal.id_canal}`}
                      onClick={() => abrirModalCanal(canal)}
                      className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                    >
                      <Edit className="w-4 h-4 text-[#1AA1D8]" />
                    </button>
                    <button
                      data-testid={`delete-canal-${canal.id_canal}`}
                      onClick={() => eliminarCanal(canal.id_canal)}
                      className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                    >
                      <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </TabsContent>

        {/* ESTADOS DE RESERVA */}
        <TabsContent value="estados">
          <div className="card-beach">
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Estados de Reserva</h2>
                <p className="text-sm text-[#0E3A53]/60 mt-1">Administra los estados disponibles para las reservas</p>
              </div>
              <Button 
                data-testid="add-estado-btn"
                onClick={() => abrirModalEstado()}
                className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
              >
                <Plus className="w-5 h-5 mr-2" />
                Nuevo Estado
              </Button>
            </div>
            <div className="space-y-3">
              {estadosReserva.map(estado => (
                <div key={estado.id_estado} className="flex items-center justify-between p-4 bg-[#8FE0FF]/10 rounded-xl hover:bg-[#8FE0FF]/20 transition-colors">
                  <div className="flex items-center gap-4">
                    <div 
                      className="w-8 h-8 rounded-lg shadow-inner flex items-center justify-center text-white font-bold text-sm"
                      style={{ backgroundColor: estado.color }}
                    >
                      {estado.orden || 0}
                    </div>
                    <div>
                      <span className="font-semibold text-[#0E3A53]">{estado.nombre}</span>
                      <span className="ml-3 text-xs text-[#0E3A53]/50">#{estado.color}</span>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => abrirModalEstado(estado)}
                      className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                      data-testid={`edit-estado-${estado.id_estado}`}
                    >
                      <Edit className="w-4 h-4 text-[#1AA1D8]" />
                    </button>
                    <button
                      onClick={() => eliminarEstado(estado.id_estado)}
                      className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                      data-testid={`delete-estado-${estado.id_estado}`}
                    >
                      <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                    </button>
                  </div>
                </div>
              ))}
              {estadosReserva.length === 0 && (
                <p className="text-center text-[#0E3A53]/50 py-8">No hay estados configurados</p>
              )}
            </div>
          </div>
        </TabsContent>

        {/* ESTADOS DE INGRESO */}
        <TabsContent value="estados-ingreso">
          <div className="card-beach">
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Estados de Ingreso</h2>
                <p className="text-sm text-[#0E3A53]/60 mt-1">Administra los estados de pago para los ingresos</p>
              </div>
              <Button 
                data-testid="add-estado-ingreso-btn"
                onClick={() => abrirModalEstadoIngreso()}
                className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
              >
                <Plus className="w-5 h-5 mr-2" />
                Nuevo Estado
              </Button>
            </div>
            <div className="space-y-3">
              {estadosIngreso.map(estado => (
                <div key={estado.id_estado} className="flex items-center justify-between p-4 bg-[#8FE0FF]/10 rounded-xl hover:bg-[#8FE0FF]/20 transition-colors">
                  <div className="flex items-center gap-4">
                    <div 
                      className="w-8 h-8 rounded-lg shadow-inner flex items-center justify-center font-bold text-sm"
                      style={{ backgroundColor: estado.color, color: estado.color_texto || '#FFFFFF' }}
                    >
                      {estado.orden || 0}
                    </div>
                    <div>
                      <span className="font-semibold text-[#0E3A53]">{estado.nombre}</span>
                      <span className="ml-3 text-xs text-[#0E3A53]/50">#{estado.color}</span>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => abrirModalEstadoIngreso(estado)}
                      className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                      data-testid={`edit-estado-ingreso-${estado.id_estado}`}
                    >
                      <Edit className="w-4 h-4 text-[#1AA1D8]" />
                    </button>
                    <button
                      onClick={() => eliminarEstadoIngreso(estado.id_estado)}
                      className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                      data-testid={`delete-estado-ingreso-${estado.id_estado}`}
                    >
                      <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                    </button>
                  </div>
                </div>
              ))}
              {estadosIngreso.length === 0 && (
                <p className="text-center text-[#0E3A53]/50 py-8">No hay estados de ingreso configurados</p>
              )}
            </div>
          </div>
        </TabsContent>

        {/* CATEGORIAS */}
        <TabsContent value="categorias">
          <div className="card-beach">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
              <div className="flex flex-wrap items-center gap-3">
                <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Categorías de Gasto</h2>
                <div 
                  className="inline-flex items-center gap-1.5 px-3 py-1 bg-emerald-50 border border-emerald-300 text-emerald-800 rounded-full shadow-sm"
                  title={`Suma de gastos mensuales máximos estimados para ${propiedadSeleccionada?.nombre || 'la propiedad activa'}`}
                >
                  <DollarSign className="w-4 h-4 text-emerald-600 shrink-0" />
                  <span className="text-xs font-semibold text-emerald-700">Total máx. est:</span>
                  <span className="text-sm font-bold text-emerald-900">{formatCurrency(totalGastoMaximoEstimado)}/mes</span>
                </div>
              </div>
              <Button 
                data-testid="add-categoria-btn"
                onClick={() => abrirModalCat()}
                className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53] shrink-0 self-start sm:self-auto"
              >
                <Plus className="w-5 h-5 mr-2" />
                Nueva Categoría
              </Button>
            </div>

            {/* Banner de propiedad activa para configurar gasto máximo */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3.5 bg-gradient-to-r from-[#8FE0FF]/25 via-[#F7E8C9]/30 to-[#8FE0FF]/25 rounded-xl mb-4 border border-[#8FE0FF]/60 shadow-sm">
              <div className="flex items-center gap-2.5">
                <div className="p-2 bg-[#1AA1D8]/20 rounded-lg text-[#0E3A53] shrink-0">
                  <DollarSign className="w-5 h-5 text-[#1AA1D8]" />
                </div>
                <div>
                  <p className="text-sm font-bold text-[#0E3A53]">Gasto Mensual Máximo Estimado por Propiedad</p>
                  <p className="text-xs text-[#0E3A53]/70">
                    Establece el tope de gasto mensual presupuestado para alertar en el Dashboard si una categoría supera el estimado.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 self-end sm:self-center shrink-0">
                <span className="text-xs font-semibold text-[#0E3A53]">Configurando:</span>
                <select
                  value={propiedadSeleccionada?.id_propiedad || ''}
                  onChange={(e) => cambiarPropiedad(e.target.value)}
                  className="px-3 py-1.5 rounded-lg bg-white text-[#0E3A53] text-xs sm:text-sm font-bold shadow-sm border-2 border-[#8FE0FF] focus:outline-none focus:ring-2 focus:ring-[#1AA1D8]"
                >
                  {propiedades.map(p => (
                    <option key={p.id_propiedad} value={p.id_propiedad}>{p.nombre}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="space-y-3">
              {categorias.map(cat => {
                const proveedoresCat = proveedoresPorCategoria(cat.id_categoria);
                const isExpandida = categoriaExpandida === cat.id_categoria;
                const maximoPropiedad = (cat.gasto_mensual_maximo || {})[propiedadSeleccionada?.id_propiedad] || 0;
                
                return (
                  <div key={cat.id_categoria} className="bg-[#8FE0FF]/10 rounded-xl overflow-hidden">
                    {/* Header de categoría */}
                    <div className="flex items-center justify-between p-4 hover:bg-[#8FE0FF]/20 transition-colors">
                      <div 
                        className="flex-1 cursor-pointer flex items-center gap-3"
                        onClick={() => setCategoriaExpandida(isExpandida ? null : cat.id_categoria)}
                      >
                        <button className="p-1">
                          {isExpandida ? <ChevronUp className="w-5 h-5 text-[#0E3A53]" /> : <ChevronDown className="w-5 h-5 text-[#0E3A53]" />}
                        </button>
                        <div>
                          <p className="font-semibold text-[#0E3A53]">{cat.nombre}</p>
                          <div className="flex flex-wrap items-center gap-2 mt-1">
                            <span className="text-xs bg-[#F7E8C9] text-[#0E3A53] px-2 py-0.5 rounded-full font-medium">{cat.tipo}</span>
                            <span className="text-xs text-[#0E3A53]/60">
                              <Users className="w-3 h-3 inline mr-1" />
                              {proveedoresCat.length} proveedor{proveedoresCat.length !== 1 ? 'es' : ''}
                            </span>
                            {/* Límite mensual estimado para la propiedad activa */}
                            {maximoPropiedad > 0 ? (
                              <span 
                                onClick={(e) => { e.stopPropagation(); abrirModalPresupuesto(cat); }}
                                className="inline-flex items-center gap-1 text-xs bg-emerald-50 text-emerald-800 border border-emerald-300 px-2.5 py-0.5 rounded-full font-semibold hover:bg-emerald-100 cursor-pointer transition-colors"
                                title={`Gasto mensual máximo para ${propiedadSeleccionada?.nombre}: ${formatCurrency(maximoPropiedad)}. Clic para editar`}
                              >
                                <DollarSign className="w-3 h-3 text-emerald-600" />
                                Máx. est: {formatCurrency(maximoPropiedad)}/mes
                              </span>
                            ) : (
                              <span 
                                onClick={(e) => { e.stopPropagation(); abrirModalPresupuesto(cat); }}
                                className="inline-flex items-center gap-1 text-xs bg-gray-100 text-[#0E3A53]/60 hover:bg-[#8FE0FF]/30 hover:text-[#0E3A53] border border-gray-200 px-2 py-0.5 rounded-full cursor-pointer transition-colors"
                                title={`Sin límite estimado para ${propiedadSeleccionada?.nombre}. Clic para asignar`}
                              >
                                <Plus className="w-3 h-3" />
                                Asignar máx. mensual
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-1">
                        <button
                          data-testid={`presupuesto-cat-${cat.id_categoria}`}
                          onClick={(e) => { e.stopPropagation(); abrirModalPresupuesto(cat); }}
                          className="p-2 hover:bg-emerald-100 rounded-lg text-emerald-700 transition-colors"
                          title={`Configurar gasto máximo mensual para ${propiedadSeleccionada?.nombre || 'propiedad'}`}
                        >
                          <DollarSign className="w-4 h-4" />
                        </button>
                        <button
                          data-testid={`edit-cat-${cat.id_categoria}`}
                          onClick={(e) => { e.stopPropagation(); abrirModalCat(cat); }}
                          className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                          title="Editar categoría"
                        >
                          <Edit className="w-4 h-4 text-[#1AA1D8]" />
                        </button>
                        <button
                          data-testid={`delete-cat-${cat.id_categoria}`}
                          onClick={(e) => { e.stopPropagation(); eliminarCategoria(cat.id_categoria); }}
                          className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                          title="Eliminar categoría"
                        >
                          <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                        </button>
                      </div>
                    </div>
                    
                    {/* Sección expandible de proveedores */}
                    {isExpandida && (
                      <div className="border-t border-[#8FE0FF]/30 p-4 bg-white/50">
                        <p className="text-sm font-medium text-[#0E3A53] mb-3">Proveedores de {cat.nombre}</p>
                        
                        {/* Lista de proveedores */}
                        {proveedoresCat.length > 0 ? (
                          <div className="space-y-2 mb-4">
                            {proveedoresCat.map(prov => (
                              <div key={prov.id_proveedor} className="flex items-center justify-between p-2 bg-[#8FE0FF]/10 rounded-lg">
                                {proveedorEditando === prov.id_proveedor ? (
                                  <div className="flex items-center gap-2 flex-1 mr-2">
                                    <Input
                                      value={nombreProveedorEdit}
                                      onChange={(e) => setNombreProveedorEdit(e.target.value)}
                                      onKeyPress={(e) => e.key === 'Enter' && guardarEdicionProveedor(prov.id_proveedor)}
                                      className="flex-1 h-8 text-sm"
                                      autoFocus
                                    />
                                    <button
                                      onClick={() => guardarEdicionProveedor(prov.id_proveedor)}
                                      className="p-1 hover:bg-green-100 rounded"
                                      title="Guardar"
                                    >
                                      <Check className="w-4 h-4 text-green-600" />
                                    </button>
                                    <button
                                      onClick={cancelarEdicionProveedor}
                                      className="p-1 hover:bg-red-100 rounded"
                                      title="Cancelar"
                                    >
                                      <X className="w-4 h-4 text-red-500" />
                                    </button>
                                  </div>
                                ) : (
                                  <>
                                    <span className="text-sm text-[#0E3A53]">{prov.nombre}</span>
                                    <div className="flex items-center gap-1">
                                      <button
                                        onClick={() => iniciarEdicionProveedor(prov)}
                                        className="p-1 hover:bg-[#1AA1D8]/20 rounded"
                                        title="Editar proveedor"
                                      >
                                        <Edit className="w-4 h-4 text-[#1AA1D8]" />
                                      </button>
                                      <button
                                        onClick={() => eliminarProveedor(prov.id_proveedor)}
                                        className="p-1 hover:bg-[#FF7F6A]/20 rounded"
                                        title="Eliminar proveedor"
                                      >
                                        <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                                      </button>
                                      
                                      <span
                                         className="ml-2 flex items-center justify-center min-w-[24px] h-6 bg-[#0E3A53] text-[#F7E8C9] text-xs font-bold rounded-full px-2"
                                         title="Gastos asociados"
                                       >
                                         {prov.gastos_count || 0}
                                       </span>
                                    </div>
                                  </>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-[#0E3A53]/50 mb-4">No hay proveedores en esta categoría</p>
                        )}
                        
                        {/* Agregar nuevo proveedor */}
                        <div className="flex gap-2">
                          <Input
                            placeholder="Nombre del proveedor"
                            value={nuevoProveedor}
                            onChange={(e) => setNuevoProveedor(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && agregarProveedor(cat.id_categoria)}
                            className="flex-1"
                          />
                          <Button
                            onClick={() => agregarProveedor(cat.id_categoria)}
                            size="sm"
                            className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
                          >
                            <Plus className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </TabsContent>

        {/* PROVEEDORES */}
        <TabsContent value="proveedores">
          <div className="card-beach">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
              <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Proveedores</h2>
              <div className="flex flex-wrap w-full md:w-auto gap-3 items-center">
                <div className="relative flex-1 min-w-[150px]">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#0E3A53]/50" />
                  <Input
                    placeholder="Buscar proveedor..."
                    value={filtroProveedor}
                    onChange={(e) => setFiltroProveedor(e.target.value)}
                    className="pl-9 w-full"
                  />
                </div>
                <button 
                  onClick={toggleTodosLosGraficos}
                  className="p-2 bg-[#8FE0FF]/20 hover:bg-[#8FE0FF]/40 text-[#0E3A53] rounded-lg transition-colors border border-[#8FE0FF]"
                  title="Expandir/Contraer todos los gráficos visibles"
                >
                  <BarChart2 className="w-5 h-5" />
                </button>
                <select
                  value={filtroCategoria}
                  onChange={(e) => setFiltroCategoria(e.target.value)}
                  className="flex-1 min-w-[150px] rounded-md border border-slate-200 bg-white px-3 py-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#1AA1D8]"
                >
                  <option value="todas">Todas las categorías</option>
                  {categorias.map(cat => (
                    <option key={cat.id_categoria} value={cat.id_categoria}>{cat.nombre}</option>
                  ))}
                </select>
                <Button 
                  onClick={() => abrirModalFusion()}
                  variant="outline"
                  className="border-[#1AA1D8] text-[#0E3A53] hover:bg-[#8FE0FF]/20 whitespace-nowrap flex items-center gap-2"
                  title="Fusionar proveedores duplicados"
                >
                  <GitMerge className="w-4 h-4 text-[#1AA1D8]" />
                  Fusionar Duplicados
                </Button>
                <Button 
                  data-testid="add-proveedor-modal-btn"
                  onClick={() => abrirModalProv()}
                  className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53] whitespace-nowrap"
                >
                  <Plus className="w-5 h-5 mr-2" />
                  Nuevo Proveedor
                </Button>
              </div>
            </div>
            <div className="space-y-3">
              {proveedores.filter(p => {
                const matchNombre = p.nombre.toLowerCase().includes(filtroProveedor.toLowerCase());
                const matchCategoria = filtroCategoria === 'todas' || p.categoria_id === filtroCategoria;
                return matchNombre && matchCategoria;
              }).length > 0 ? proveedores.filter(p => {
                const matchNombre = p.nombre.toLowerCase().includes(filtroProveedor.toLowerCase());
                const matchCategoria = filtroCategoria === 'todas' || p.categoria_id === filtroCategoria;
                return matchNombre && matchCategoria;
              }).sort((a, b) => a.nombre.localeCompare(b.nombre)).map(prov => {
                const catProv = categorias.find(c => c.id_categoria === prov.categoria_id);
                const isExpandido = proveedoresExpandidos.has(prov.id_proveedor);
                return (
                  <div key={prov.id_proveedor} className="bg-[#8FE0FF]/10 rounded-xl overflow-hidden">
                    <div 
                      className="flex items-center justify-between p-4 hover:bg-[#8FE0FF]/20 transition-colors cursor-pointer"
                      onClick={() => toggleProveedorGrafico(prov)}
                    >
                      <div className="flex items-center gap-3">
                        <button className="p-1">
                          {isExpandido ? <ChevronUp className="w-5 h-5 text-[#0E3A53]" /> : <ChevronDown className="w-5 h-5 text-[#0E3A53]" />}
                        </button>
                        <div>
                          <p className="font-semibold text-[#0E3A53]">{prov.nombre}</p>
                          {catProv && (
                            <span className="text-xs bg-[#F7E8C9] text-[#0E3A53] px-2 py-1 rounded-full mt-1 inline-block">
                              {catProv.nombre}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={(e) => { e.stopPropagation(); abrirModalFusion(prov); }}
                          className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg text-[#0E3A53]"
                          title="Fusionar este proveedor con otro"
                        >
                          <GitMerge className="w-4 h-4 text-[#1AA1D8]" />
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); toggleProveedorGrafico(prov); }}
                          className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                          title="Ver gastos por propiedad"
                        >
                          <BarChart2 className="w-4 h-4 text-[#1AA1D8]" />
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); abrirModalProv(prov); }}
                          className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                          title="Editar proveedor"
                        >
                          <Edit className="w-4 h-4 text-[#1AA1D8]" />
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); eliminarProveedor(prov.id_proveedor); }}
                          className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                          title="Eliminar proveedor"
                        >
                          <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                        </button>
                        
                        <span
                           className="ml-2 flex items-center justify-center min-w-[32px] h-8 bg-[#0E3A53] text-[#F7E8C9] text-sm font-bold rounded-full px-3"
                           title="Gastos asociados"
                         >
                           {prov.gastos_count || 0}
                         </span>
                      </div>
                    </div>
                    {isExpandido && (
                      <div className="border-t border-[#8FE0FF]/30 p-6 bg-white/80">
                        <h3 className="text-lg font-semibold text-[#0E3A53] mb-4 flex items-center gap-2">
                          Gastos Anuales por Propiedad (
                          <select
                            value={anioGrafico}
                            onChange={(e) => cambiarAnioGrafico(e.target.value)}
                            className="rounded-md border border-slate-200 bg-white px-2 py-0.5 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#1AA1D8] text-[#0E3A53] font-semibold cursor-pointer"
                          >
                            {aniosDisponiblesGrafico.map(anio => (
                              <option key={anio} value={anio}>{anio}</option>
                            ))}
                          </select>
                          )
                        </h3>
                        {cargandoGraficos[prov.id_proveedor] ? (
                          <div className="flex justify-center py-8">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1AA1D8]"></div>
                          </div>
                        ) : datosGraficos[prov.id_proveedor]?.propiedades && datosGraficos[prov.id_proveedor].propiedades.length > 0 ? (
                          <div className="space-y-8">
                            {datosGraficos[prov.id_proveedor].propiedades.map((propName, index) => {
                              const colors = ['#8FE0FF', '#FF7F6A', '#FFD166', '#06D6A0', '#118AB2', '#EF476F'];
                              let color = colors[index % colors.length];
                              if (propName.toLowerCase().includes('morrillo')) {
                                color = '#1AA1D8';
                              } else if (propName.toLowerCase().includes('chicureo')) {
                                color = '#0E3A53';
                              }
                               const prop = todasLasPropiedades.find(p => p.nombre === propName);
                              const propId = prop ? prop.id_propiedad : '';
                              return (
                                <div 
                                  key={propName}
                                  onClick={() => {
                                    if (propId) {
                                      navigate(`/admin/gastos?proveedor_id=${prov.id_proveedor}&propiedad_id=${propId}`);
                                    } else {
                                      navigate(`/admin/gastos?proveedor_id=${prov.id_proveedor}`);
                                    }
                                  }}
                                  className="cursor-pointer hover:bg-[#8FE0FF]/5 p-4 rounded-xl border border-transparent hover:border-[#8FE0FF]/30 transition-all group"
                                  title={`Hacer clic para ver el detalle de gastos de ${prov.nombre} en ${propName}`}
                                >
                                  <h4 className="text-md font-semibold text-[#0E3A53] mb-2 flex items-center gap-2 group-hover:text-[#1AA1D8] transition-colors">
                                    {propName}
                                    <span className="text-xs font-normal text-[#0E3A53]/50">(Ver gastos)</span>
                                  </h4>
                                  <div className="h-48 w-full">
                                    <ResponsiveContainer width="100%" height="100%">
                                      <BarChart data={datosGraficos[prov.id_proveedor].data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
                                        <XAxis dataKey="name" tick={{fill: '#0E3A53'}} axisLine={{stroke: '#0E3A53'}} />
                                        <YAxis 
                                          tick={{fill: '#0E3A53'}} 
                                          axisLine={{stroke: '#0E3A53'}}
                                          tickFormatter={(value) => `$${value.toLocaleString()}`}
                                        />
                                        <Tooltip 
                                          formatter={(value) => [`$${value.toLocaleString()}`, 'Gasto']}
                                          contentStyle={{borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'}}
                                        />
                                        <Bar dataKey={propName} fill={color} radius={[4, 4, 0, 0]} />
                                      </BarChart>
                                    </ResponsiveContainer>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <p className="text-center text-[#0E3A53]/60 py-6">No hay gastos registrados para este proveedor en este año.</p>
                        )}
                      </div>
                    )}
                  </div>
                );
              }) : (
                <p className="text-center text-[#0E3A53]/50 py-8">
                  {proveedores.length === 0 ? "No hay proveedores configurados" : "No se encontraron proveedores que coincidan con la búsqueda"}
                </p>
              )}
            </div>
          </div>
        </TabsContent>

        {/* MEDIOS DE PAGO */}
        <TabsContent value="medios-pago">
          <div className="card-beach">
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Medios de Pago</h2>
                <p className="text-sm text-[#0E3A53]/60 mt-1">Administra los medios de pago disponibles para gastos</p>
              </div>
              <Button 
                data-testid="add-medio-pago-btn"
                onClick={() => abrirModalMedioPago()}
                className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
              >
                <Plus className="w-5 h-5 mr-2" />
                Nuevo Medio de Pago
              </Button>
            </div>
            <div className="space-y-3">
              {mediosPago.map(medio => (
                <div key={medio.id_medio_pago} className="flex items-center justify-between p-4 bg-[#8FE0FF]/10 rounded-xl hover:bg-[#8FE0FF]/20 transition-colors">
                  <div className="flex items-center gap-4">
                    <div 
                      className={`w-10 h-10 rounded-lg shadow-inner flex items-center justify-center ${medio.activo ? 'bg-green-500' : 'bg-gray-400'}`}
                    >
                      <CreditCard className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <span className="font-semibold text-[#0E3A53]">{medio.nombre}</span>
                      <span className={`ml-3 text-xs px-2 py-1 rounded-full ${medio.activo !== false ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                        {medio.activo !== false ? 'Activo' : 'Inactivo'}
                      </span>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => abrirModalMedioPago(medio)}
                      className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                      data-testid={`edit-medio-pago-${medio.id_medio_pago}`}
                    >
                      <Edit className="w-4 h-4 text-[#1AA1D8]" />
                    </button>
                    <button
                      onClick={() => eliminarMedioPago(medio.id_medio_pago)}
                      className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                      data-testid={`delete-medio-pago-${medio.id_medio_pago}`}
                    >
                      <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                    </button>
                  </div>
                </div>
              ))}
              {mediosPago.length === 0 && (
                <p className="text-center text-[#0E3A53]/50 py-8">No hay medios de pago configurados</p>
              )}
            </div>
          </div>
        </TabsContent>

        {/* USUARIOS (Solo Admin) */}
        {isAdmin() && (
          <TabsContent value="usuarios">
            <div className="card-beach">
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h2 className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Usuarios</h2>
                  <p className="text-sm text-[#0E3A53]/60 mt-1">Administra los usuarios y sus permisos de acceso</p>
                </div>
                <Button 
                  data-testid="add-usuario-btn"
                  onClick={() => abrirModalUsuario()}
                  className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
                >
                  <Plus className="w-5 h-5 mr-2" />
                  Nuevo Usuario
                </Button>
              </div>
              <div className="space-y-3">
                {usuarios.map(usuario => (
                  <div key={usuario.id_usuario} className="p-4 bg-[#8FE0FF]/10 rounded-xl hover:bg-[#8FE0FF]/20 transition-colors">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div 
                          className={`w-12 h-12 rounded-xl shadow-inner flex items-center justify-center ${usuario.activo ? 'bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]' : 'bg-gray-400'}`}
                        >
                          <UserCog className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-[#0E3A53]">{usuario.email}</span>
                            {usuario.is_admin && (
                              <span className="text-xs px-2 py-0.5 rounded-full bg-[#1AA1D8] text-white font-semibold">Admin</span>
                            )}
                            <span className={`text-xs px-2 py-0.5 rounded-full ${usuario.activo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                              {usuario.activo ? 'Activo' : 'Inactivo'}
                            </span>
                          </div>
                          <div className="flex flex-wrap gap-1 mt-1">
                            {(usuario.propiedades_asignadas || []).length > 0 ? (
                              usuario.propiedades_asignadas.slice(0, 3).map(propId => (
                                <span key={propId} className="text-xs px-2 py-0.5 bg-[#F7E8C9] rounded text-[#0E3A53]">
                                  {obtenerNombrePropiedad(propId)}
                                </span>
                              ))
                            ) : (
                              <span className="text-xs text-[#0E3A53]/50">Sin propiedades asignadas</span>
                            )}
                            {(usuario.propiedades_asignadas || []).length > 3 && (
                              <span className="text-xs px-2 py-0.5 bg-[#8FE0FF]/50 rounded text-[#0E3A53]">
                                +{usuario.propiedades_asignadas.length - 3} más
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => abrirModalUsuario(usuario)}
                          className="p-2 hover:bg-[#1AA1D8]/20 rounded-lg"
                          data-testid={`edit-usuario-${usuario.id_usuario}`}
                        >
                          <Edit className="w-4 h-4 text-[#1AA1D8]" />
                        </button>
                        <button
                          onClick={() => eliminarUsuario(usuario.id_usuario)}
                          className="p-2 hover:bg-[#FF7F6A]/20 rounded-lg"
                          data-testid={`delete-usuario-${usuario.id_usuario}`}
                        >
                          <Trash2 className="w-4 h-4 text-[#FF7F6A]" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                {usuarios.length === 0 && (
                  <p className="text-center text-[#0E3A53]/50 py-8">No hay usuarios registrados</p>
                )}
              </div>
            </div>
          </TabsContent>
        )}
      </Tabs>

      {/* Modal Propiedad */}
      <Dialog open={modalPropAbierto} onOpenChange={setModalPropAbierto}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Propiedad' : 'Nueva Propiedad'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-6">
            {/* Información Básica */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label htmlFor="nombre-prop">Nombre</Label>
                <Input
                  id="nombre-prop"
                  data-testid="input-nombre-prop"
                  value={formProp.nombre}
                  onChange={(e) => setFormProp({ ...formProp, nombre: e.target.value })}
                />
              </div>
              <div>
                <Label htmlFor="ubicacion">Ubicación</Label>
                <Input
                  id="ubicacion"
                  data-testid="input-ubicacion"
                  value={formProp.ubicacion}
                  onChange={(e) => setFormProp({ ...formProp, ubicacion: e.target.value })}
                />
              </div>
            </div>

            {/* Capacidad, Dormitorios y Baños */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label htmlFor="capacidad">Capacidad (personas)</Label>
                <Input
                  id="capacidad"
                  type="number"
                  min="0"
                  value={formProp.capacidad}
                  onChange={(e) => setFormProp({ ...formProp, capacidad: e.target.value })}
                  placeholder="Ej: 6"
                />
              </div>
              <div>
                <Label htmlFor="dormitorios">Dormitorios</Label>
                <Input
                  id="dormitorios"
                  type="number"
                  min="0"
                  value={formProp.dormitorios}
                  onChange={(e) => handleDormitoriosChange(e.target.value)}
                  placeholder="Ej: 3"
                />
              </div>
              <div>
                <Label htmlFor="banos">Baños</Label>
                <Input
                  id="banos"
                  type="number"
                  min="0"
                  value={formProp.banos}
                  onChange={(e) => setFormProp({ ...formProp, banos: e.target.value })}
                  placeholder="Ej: 2"
                />
              </div>
            </div>

            {/* Descripciones de Dormitorios */}
            {formProp.dormitorios_descripciones.length > 0 && (
              <div className="space-y-3">
                <Label className="text-base font-semibold text-cyan-800">
                  Descripción de cada Dormitorio
                </Label>
                {formProp.dormitorios_descripciones.map((dormitorio) => (
                  <div key={dormitorio.numero} className="flex gap-2 items-center">
                    <span className="text-sm font-medium w-24 text-gray-600">
                      Dormitorio {dormitorio.numero}:
                    </span>
                    <Input
                      value={dormitorio.descripcion}
                      onChange={(e) => updateDormitorioDescripcion(dormitorio.numero, e.target.value)}
                      placeholder="Ej: 1 cama queen, closet, aire acondicionado"
                      className="flex-1"
                    />
                  </div>
                ))}
              </div>
            )}

            {/* Más Características */}
            <div>
              <Label htmlFor="caracteristicas">Más Características</Label>
              <textarea
                id="caracteristicas"
                value={formProp.caracteristicas}
                onChange={(e) => setFormProp({ ...formProp, caracteristicas: e.target.value })}
                rows={4}
                placeholder="Ej: WiFi, TV cable, cocina equipada, estacionamiento..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
              />
            </div>

            {/* Condiciones de Pago */}
            <div>
              <Label htmlFor="condiciones_pago">Condiciones de Pago</Label>
              <textarea
                id="condiciones_pago"
                value={formProp.condiciones_pago}
                onChange={(e) => setFormProp({ ...formProp, condiciones_pago: e.target.value })}
                rows={4}
                placeholder="Ej: 50% anticipo, 50% al check-in..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
              />
            </div>

            {/* Tipo de Arriendo - ANTES de la gestión de precios */}
            <div className="border-2 border-purple-200 rounded-xl p-4 bg-purple-50/30">
              <Label className="text-base font-semibold text-purple-800 mb-3 flex items-center gap-2">
                <Calendar className="w-5 h-5" />
                Tipo de Arriendo
              </Label>
              <div>
                <select
                  id="tipo_arriendo"
                  value={formProp.tipo_arriendo}
                  onChange={(e) => setFormProp({ ...formProp, tipo_arriendo: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-base"
                >
                  <option value="seasonal">🏖️ Por Temporada (Noche)</option>
                  <option value="monthly">🏠 Contrato Mensual</option>
                </select>
                <div className="mt-2 p-3 bg-white rounded-lg border border-purple-200">
                  <p className="text-sm text-gray-700">
                    {formProp.tipo_arriendo === 'seasonal' 
                      ? '📅 Arriendo por noche con precios variables según temporada. Permite configurar precios personalizados por fechas y descuentos.' 
                      : '📆 Arriendo mensual con tarifa fija. El sistema calculará automáticamente el costo proporcional para estadías menores a 30 días.'}
                  </p>
                </div>
              </div>
            </div>

            {/* Precios */}
            <div className="border-2 border-cyan-200 rounded-xl p-4 bg-cyan-50/30">
              <Label className="text-base font-semibold text-cyan-800 mb-3 flex items-center gap-2">
                <DollarSign className="w-5 h-5" />
                Gestión de Precios {formProp.tipo_arriendo === 'monthly' && '(Mensual)'}
              </Label>

              {/* Precio Base - Condicional según tipo */}
              {formProp.tipo_arriendo === 'seasonal' ? (
                <div className="mb-4">
                  <Label htmlFor="precio_base">Precio Base por Noche (CLP)</Label>
                  <Input
                    id="precio_base"
                    type="number"
                    min="0"
                    step="1000"
                    value={formProp.precio_base_noche}
                    onChange={(e) => setFormProp({ ...formProp, precio_base_noche: parseFloat(e.target.value) || 0 })}
                    placeholder="50000"
                    className="text-lg font-semibold"
                  />
                </div>
              ) : (
                <div className="mb-4">
                  <Label htmlFor="precio_mensual">Precio Mensual (CLP)</Label>
                  <Input
                    id="precio_mensual"
                    type="number"
                    min="0"
                    step="10000"
                    value={formProp.precio_mensual}
                    onChange={(e) => setFormProp({ ...formProp, precio_mensual: parseFloat(e.target.value) || 0 })}
                    placeholder="1200000"
                    className="text-lg font-semibold"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Para estadías menores a 30 días se cobrará de forma proporcional
                  </p>
                </div>
              )}

              {/* Precios Personalizados - Solo para seasonal */}
              {formProp.tipo_arriendo === 'seasonal' && (
                <div className="mb-4">
                <Label className="flex items-center gap-2 mb-2">
                  <Calendar className="w-4 h-4" />
                  Precios Personalizados por Rango de Fechas
                </Label>
                <div className="space-y-2">
                  {formProp.precios_personalizados.map((precio, idx) => (
                    <div key={idx} className="bg-white p-3 rounded border space-y-2">
                      <div className="flex gap-2">
                        <div className="flex-1">
                          <Label className="text-xs">Desde</Label>
                          <Input
                            type="date"
                            value={precio.fecha_inicio}
                            onChange={(e) => {
                              const nuevos = [...formProp.precios_personalizados];
                              nuevos[idx].fecha_inicio = e.target.value;
                              setFormProp({ ...formProp, precios_personalizados: nuevos });
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <Label className="text-xs">Hasta</Label>
                          <Input
                            type="date"
                            value={precio.fecha_fin}
                            onChange={(e) => {
                              const nuevos = [...formProp.precios_personalizados];
                              nuevos[idx].fecha_fin = e.target.value;
                              setFormProp({ ...formProp, precios_personalizados: nuevos });
                            }}
                          />
                        </div>
                        <div className="w-32">
                          <Label className="text-xs">Precio</Label>
                          <Input
                            type="number"
                            min="0"
                            step="1000"
                            value={precio.precio_noche}
                            onChange={(e) => {
                              const nuevos = [...formProp.precios_personalizados];
                              nuevos[idx].precio_noche = parseFloat(e.target.value) || 0;
                              setFormProp({ ...formProp, precios_personalizados: nuevos });
                            }}
                            placeholder="Precio"
                          />
                        </div>
                        <div className="flex items-end">
                          <button
                            type="button"
                            onClick={() => {
                              const nuevos = formProp.precios_personalizados.filter((_, i) => i !== idx);
                              setFormProp({ ...formProp, precios_personalizados: nuevos });
                            }}
                            className="px-3 py-2 bg-red-100 text-red-600 rounded hover:bg-red-200"
                          >
                            <X className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      const hoy = new Date().toISOString().split('T')[0];
                      const manana = new Date(Date.now() + 86400000).toISOString().split('T')[0];
                      setFormProp({
                        ...formProp,
                        precios_personalizados: [
                          ...formProp.precios_personalizados,
                          { fecha_inicio: hoy, fecha_fin: manana, precio_noche: formProp.precio_base_noche }
                        ]
                      });
                    }}
                    className="w-full py-2 border-2 border-dashed border-cyan-300 rounded text-cyan-600 hover:bg-cyan-50 flex items-center justify-center gap-2"
                  >
                    <Plus className="w-4 h-4" />
                    Agregar Precio Personalizado
                  </button>
                </div>
                </div>
              )}

              {/* Descuentos/Promociones - Solo para seasonal */}
              {formProp.tipo_arriendo === 'seasonal' && (
                <div>
                <Label className="flex items-center gap-2 mb-2">
                  <Percent className="w-4 h-4" />
                  Descuentos y Promociones
                </Label>
                <div className="space-y-2">
                  {formProp.descuentos.map((descuento, idx) => (
                    <div key={idx} className="bg-white p-3 rounded border space-y-2">
                      <Input
                        type="text"
                        value={descuento.nombre}
                        onChange={(e) => {
                          const nuevos = [...formProp.descuentos];
                          nuevos[idx].nombre = e.target.value;
                          setFormProp({ ...formProp, descuentos: nuevos });
                        }}
                        placeholder="Nombre de la promoción (ej: Verano 2025)"
                        className="font-semibold"
                      />
                      <div className="flex gap-2">
                        <div className="flex-1">
                          <Label className="text-xs">Desde</Label>
                          <Input
                            type="date"
                            value={descuento.fecha_inicio}
                            onChange={(e) => {
                              const nuevos = [...formProp.descuentos];
                              nuevos[idx].fecha_inicio = e.target.value;
                              setFormProp({ ...formProp, descuentos: nuevos });
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <Label className="text-xs">Hasta</Label>
                          <Input
                            type="date"
                            value={descuento.fecha_fin}
                            onChange={(e) => {
                              const nuevos = [...formProp.descuentos];
                              nuevos[idx].fecha_fin = e.target.value;
                              setFormProp({ ...formProp, descuentos: nuevos });
                            }}
                          />
                        </div>
                        <div className="w-24">
                          <Label className="text-xs">% Desc.</Label>
                          <Input
                            type="number"
                            min="0"
                            max="100"
                            value={descuento.porcentaje}
                            onChange={(e) => {
                              const nuevos = [...formProp.descuentos];
                              nuevos[idx].porcentaje = parseFloat(e.target.value) || 0;
                              setFormProp({ ...formProp, descuentos: nuevos });
                            }}
                            placeholder="%"
                          />
                        </div>
                        <div className="flex items-end">
                          <button
                            type="button"
                            onClick={() => {
                              const nuevos = formProp.descuentos.filter((_, i) => i !== idx);
                              setFormProp({ ...formProp, descuentos: nuevos });
                            }}
                            className="px-3 py-2 bg-red-100 text-red-600 rounded hover:bg-red-200"
                          >
                            <X className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      const hoy = new Date().toISOString().split('T')[0];
                      const manana = new Date(Date.now() + 86400000).toISOString().split('T')[0];
                      setFormProp({
                        ...formProp,
                        descuentos: [
                          ...formProp.descuentos,
                          { nombre: 'Nueva Promoción', fecha_inicio: hoy, fecha_fin: manana, porcentaje: 10 }
                        ]
                      });
                    }}
                    className="w-full py-2 border-2 border-dashed border-cyan-300 rounded text-cyan-600 hover:bg-cyan-50 flex items-center justify-center gap-2"
                  >
                    <Plus className="w-4 h-4" />
                    Agregar Descuento/Promoción
                  </button>
                </div>
                </div>
              )}

              {/* Otros Cobros */}
              <div>
                <Label className="flex items-center gap-2 mb-2">
                  <DollarSign className="w-4 h-4" />
                  Otros Cobros (Aseo, Toallas, etc.)
                </Label>
                <div className="space-y-2">
                  {formProp.otros_cobros.map((cobro, idx) => (
                    <div key={idx} className="bg-white p-3 rounded border">
                      <div className="flex gap-2 items-center">
                        <div className="flex-1">
                          <Input
                            type="text"
                            value={cobro.nombre}
                            onChange={(e) => {
                              const nuevos = [...formProp.otros_cobros];
                              nuevos[idx].nombre = e.target.value;
                              setFormProp({ ...formProp, otros_cobros: nuevos });
                            }}
                            placeholder="Ej: Aseo"
                            className="font-semibold"
                          />
                        </div>
                        <div className="w-32">
                          <Input
                            type="number"
                            min="0"
                            step="1000"
                            value={cobro.monto}
                            onChange={(e) => {
                              const nuevos = [...formProp.otros_cobros];
                              nuevos[idx].monto = parseFloat(e.target.value) || 0;
                              setFormProp({ ...formProp, otros_cobros: nuevos });
                            }}
                            placeholder="Monto"
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              checked={cobro.activo}
                              onChange={(e) => {
                                const nuevos = [...formProp.otros_cobros];
                                nuevos[idx].activo = e.target.checked;
                                setFormProp({ ...formProp, otros_cobros: nuevos });
                              }}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-cyan-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600"></div>
                            <span className="ml-2 text-sm font-medium text-gray-700">
                              {cobro.activo ? 'Activo' : 'Inactivo'}
                            </span>
                          </label>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            const nuevos = formProp.otros_cobros.filter((_, i) => i !== idx);
                            setFormProp({ ...formProp, otros_cobros: nuevos });
                          }}
                          className="px-3 py-2 bg-red-100 text-red-600 rounded hover:bg-red-200"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      setFormProp({
                        ...formProp,
                        otros_cobros: [
                          ...formProp.otros_cobros,
                          { nombre: 'Aseo', monto: 0, activo: true }
                        ]
                      });
                    }}
                    className="w-full py-2 border-2 border-dashed border-cyan-300 rounded text-cyan-600 hover:bg-cyan-50 flex items-center justify-center gap-2"
                  >
                    <Plus className="w-4 h-4" />
                    Agregar Otro Cobro
                  </button>
                </div>
              </div>
            </div>

            {/* Fotos */}
            <div>
              <Label htmlFor="fotos" className="text-base font-semibold text-cyan-800 mb-2 block">
                Fotos de la Propiedad
              </Label>
              <div className="space-y-3">
                <Input
                  id="fotos"
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => setArchivosPropiedad(Array.from(e.target.files))}
                  disabled={subiendoFotos}
                  className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-cyan-50 file:text-cyan-700 hover:file:bg-cyan-100"
                />
                
                {/* Preview de nuevas fotos */}
                {archivosPropiedad.length > 0 && (
                  <div className="flex flex-wrap gap-2">
                    {archivosPropiedad.map((file, idx) => (
                      <div key={idx} className="relative w-20 h-20 border rounded overflow-hidden">
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`Preview ${idx + 1}`}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute top-0 right-0 bg-green-500 text-white text-xs px-1">
                          Nueva
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Fotos existentes */}
                {formProp.fotos.length > 0 && (
                  <div>
                    <Label className="text-sm text-gray-600">Fotos actuales (arrastra para reordenar):</Label>
                    <div className="flex flex-wrap gap-3 mt-2">
                      {formProp.fotos.map((url, idx) => (
                        <div key={idx} className={`relative border-2 rounded-lg overflow-hidden group bg-white ${
                          formProp.foto_fondo_index === idx ? 'border-yellow-400 ring-2 ring-yellow-400' : 'border-gray-200'
                        }`}>
                          <div className="relative w-24 h-24">
                            <img
                              src={`${BACKEND_URL}${url}`}
                              alt={`Foto ${idx + 1}`}
                              className="w-full h-full object-cover"
                            />
                            {/* Badge de número */}
                            <div className="absolute top-1 left-1 bg-cyan-600 text-white text-xs font-bold px-2 py-0.5 rounded">
                              {idx + 1}
                            </div>
                            {/* Indicador de foto de fondo */}
                            {formProp.foto_fondo_index === idx && (
                              <div className="absolute top-1 right-1 bg-yellow-500 text-white text-xs font-bold px-2 py-0.5 rounded flex items-center gap-1">
                                <Star className="w-3 h-3 fill-current" />
                                Fondo
                              </div>
                            )}
                          </div>
                          
                          {/* Controles */}
                          <div className="grid grid-cols-4 border-t border-gray-200">
                            {/* Mover arriba */}
                            <button
                              type="button"
                              onClick={() => moverFotoArriba(idx)}
                              disabled={idx === 0}
                              className={`p-1 ${
                                idx === 0 
                                  ? 'bg-gray-100 text-gray-300 cursor-not-allowed' 
                                  : 'bg-cyan-50 text-cyan-600 hover:bg-cyan-100'
                              } transition-colors`}
                              title="Mover arriba"
                            >
                              <ChevronUp className="w-3 h-3 mx-auto" />
                            </button>
                            
                            {/* Mover abajo */}
                            <button
                              type="button"
                              onClick={() => moverFotoAbajo(idx)}
                              disabled={idx === formProp.fotos.length - 1}
                              className={`p-1 border-l border-gray-200 ${
                                idx === formProp.fotos.length - 1
                                  ? 'bg-gray-100 text-gray-300 cursor-not-allowed' 
                                  : 'bg-cyan-50 text-cyan-600 hover:bg-cyan-100'
                              } transition-colors`}
                              title="Mover abajo"
                            >
                              <ChevronDown className="w-3 h-3 mx-auto" />
                            </button>
                            
                            {/* Marcar como fondo */}
                            <button
                              type="button"
                              onClick={() => setFormProp({...formProp, foto_fondo_index: idx})}
                              className={`p-1 border-l border-gray-200 ${
                                formProp.foto_fondo_index === idx
                                  ? 'bg-yellow-100 text-yellow-600'
                                  : 'bg-yellow-50 text-yellow-600 hover:bg-yellow-100'
                              } transition-colors`}
                              title="Usar como fondo"
                            >
                              <Star className={`w-3 h-3 mx-auto ${formProp.foto_fondo_index === idx ? 'fill-current' : ''}`} />
                            </button>
                            
                            {/* Eliminar */}
                            <button
                              type="button"
                              onClick={() => eliminarFoto(idx)}
                              className="p-1 border-l border-gray-200 bg-red-50 text-red-600 hover:bg-red-100 transition-colors"
                              title="Eliminar"
                            >
                              <X className="w-3 h-3 mx-auto" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="text-xs text-gray-500 mt-2 space-y-1">
                      <p>💡 La primera foto será la foto principal en la galería</p>
                      <p>⭐ La foto marcada con estrella será el fondo de la página pública</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="flex gap-3 justify-end mt-6 pt-4 border-t">
            <Button variant="outline" onClick={() => setModalPropAbierto(false)} data-testid="cancel-prop-btn">
              Cancelar
            </Button>
            <Button 
              onClick={guardarPropiedad} 
              data-testid="save-prop-btn" 
              disabled={subiendoFotos}
              className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
            >
              {subiendoFotos ? (
                <span className="flex items-center gap-2">
                  <Upload className="w-4 h-4 animate-spin" />
                  Subiendo fotos...
                </span>
              ) : (
                'Guardar'
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Canal */}
      <Dialog open={modalCanalAbierto} onOpenChange={setModalCanalAbierto}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Canal' : 'Nuevo Canal'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre-canal">Nombre</Label>
              <Input
                id="nombre-canal"
                data-testid="input-nombre-canal"
                value={formCanal.nombre}
                onChange={(e) => setFormCanal({ ...formCanal, nombre: e.target.value })}
              />
            </div>
            <div>
              <Label htmlFor="color-canal">Color</Label>
              <div className="flex gap-3">
                <Input
                  id="color-canal"
                  data-testid="input-color-canal"
                  type="color"
                  value={formCanal.color}
                  onChange={(e) => setFormCanal({ ...formCanal, color: e.target.value })}
                  className="w-20 h-10"
                />
                <Input
                  value={formCanal.color}
                  onChange={(e) => setFormCanal({ ...formCanal, color: e.target.value })}
                  className="flex-1"
                />
              </div>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalCanalAbierto(false)} data-testid="cancel-canal-btn">Cancelar</Button>
            <Button onClick={guardarCanal} data-testid="save-canal-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Estado de Reserva */}
      <Dialog open={modalEstadoAbierto} onOpenChange={setModalEstadoAbierto}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Estado' : 'Nuevo Estado'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre-estado">Nombre</Label>
              <Input
                id="nombre-estado"
                data-testid="input-nombre-estado"
                value={formEstado.nombre}
                onChange={(e) => setFormEstado({ ...formEstado, nombre: e.target.value })}
                placeholder="Ej: Confirmada, Pendiente..."
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="color-estado">Color de Fondo</Label>
                <div className="flex gap-2 mt-1">
                  <Input
                    id="color-estado"
                    data-testid="input-color-estado"
                    type="color"
                    value={formEstado.color}
                    onChange={(e) => setFormEstado({ ...formEstado, color: e.target.value })}
                    className="w-14 h-10"
                  />
                  <Input
                    value={formEstado.color}
                    onChange={(e) => setFormEstado({ ...formEstado, color: e.target.value })}
                    className="flex-1"
                  />
                </div>
              </div>
              <div>
                <Label htmlFor="color-texto-estado">Color de Texto</Label>
                <div className="flex gap-2 mt-1">
                  <Input
                    id="color-texto-estado"
                    data-testid="input-color-texto-estado"
                    type="color"
                    value={formEstado.color_texto}
                    onChange={(e) => setFormEstado({ ...formEstado, color_texto: e.target.value })}
                    className="w-14 h-10"
                  />
                  <Input
                    value={formEstado.color_texto}
                    onChange={(e) => setFormEstado({ ...formEstado, color_texto: e.target.value })}
                    className="flex-1"
                  />
                </div>
              </div>
            </div>
            <div>
              <Label htmlFor="orden-estado">Orden</Label>
              <Input
                id="orden-estado"
                data-testid="input-orden-estado"
                type="number"
                min="0"
                value={formEstado.orden}
                onChange={(e) => setFormEstado({ ...formEstado, orden: parseInt(e.target.value) || 0 })}
              />
              <p className="text-xs text-[#0E3A53]/50 mt-1">Define el orden de aparición en los selectores</p>
            </div>
            <div className="p-3 bg-[#8FE0FF]/10 rounded-lg">
              <Label className="text-sm text-[#0E3A53]/70">Vista previa</Label>
              <div className="mt-2">
                <span 
                  className="px-4 py-2 rounded-full text-sm font-medium inline-block"
                  style={{ 
                    backgroundColor: formEstado.color,
                    color: formEstado.color_texto
                  }}
                >
                  {formEstado.nombre || 'Estado'}
                </span>
              </div>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalEstadoAbierto(false)} data-testid="cancel-estado-btn">Cancelar</Button>
            <Button onClick={guardarEstado} data-testid="save-estado-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Estado de Ingreso */}
      <Dialog open={modalEstadoIngresoAbierto} onOpenChange={setModalEstadoIngresoAbierto}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Estado de Ingreso' : 'Nuevo Estado de Ingreso'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre-estado-ingreso">Nombre</Label>
              <Input
                id="nombre-estado-ingreso"
                data-testid="input-nombre-estado-ingreso"
                value={formEstadoIngreso.nombre}
                onChange={(e) => setFormEstadoIngreso({ ...formEstadoIngreso, nombre: e.target.value })}
                placeholder="Ej: Pendiente, Abonado, Pagado..."
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="color-estado-ingreso">Color de Fondo</Label>
                <div className="flex gap-2 mt-1">
                  <Input
                    id="color-estado-ingreso"
                    data-testid="input-color-estado-ingreso"
                    type="color"
                    value={formEstadoIngreso.color}
                    onChange={(e) => setFormEstadoIngreso({ ...formEstadoIngreso, color: e.target.value })}
                    className="w-14 h-10"
                  />
                  <Input
                    value={formEstadoIngreso.color}
                    onChange={(e) => setFormEstadoIngreso({ ...formEstadoIngreso, color: e.target.value })}
                    className="flex-1"
                  />
                </div>
              </div>
              <div>
                <Label htmlFor="color-texto-estado-ingreso">Color de Texto</Label>
                <div className="flex gap-2 mt-1">
                  <Input
                    id="color-texto-estado-ingreso"
                    data-testid="input-color-texto-estado-ingreso"
                    type="color"
                    value={formEstadoIngreso.color_texto}
                    onChange={(e) => setFormEstadoIngreso({ ...formEstadoIngreso, color_texto: e.target.value })}
                    className="w-14 h-10"
                  />
                  <Input
                    value={formEstadoIngreso.color_texto}
                    onChange={(e) => setFormEstadoIngreso({ ...formEstadoIngreso, color_texto: e.target.value })}
                    className="flex-1"
                  />
                </div>
              </div>
            </div>
            <div>
              <Label htmlFor="orden-estado-ingreso">Orden</Label>
              <Input
                id="orden-estado-ingreso"
                data-testid="input-orden-estado-ingreso"
                type="number"
                min="0"
                value={formEstadoIngreso.orden}
                onChange={(e) => setFormEstadoIngreso({ ...formEstadoIngreso, orden: parseInt(e.target.value) || 0 })}
              />
              <p className="text-xs text-[#0E3A53]/50 mt-1">Define el orden de aparición en los selectores</p>
            </div>
            <div className="p-3 bg-[#8FE0FF]/10 rounded-lg">
              <Label className="text-sm text-[#0E3A53]/70">Vista previa</Label>
              <div className="mt-2">
                <span 
                  className="px-4 py-2 rounded-full text-sm font-medium inline-block"
                  style={{ 
                    backgroundColor: formEstadoIngreso.color,
                    color: formEstadoIngreso.color_texto
                  }}
                >
                  {formEstadoIngreso.nombre || 'Estado'}
                </span>
              </div>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalEstadoIngresoAbierto(false)} data-testid="cancel-estado-ingreso-btn">Cancelar</Button>
            <Button onClick={guardarEstadoIngreso} data-testid="save-estado-ingreso-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Categoria */}
      <Dialog open={modalCatAbierto} onOpenChange={setModalCatAbierto}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Categoría' : 'Nueva Categoría'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre-cat">Nombre</Label>
              <Input
                id="nombre-cat"
                data-testid="input-nombre-cat"
                value={formCat.nombre}
                onChange={(e) => setFormCat({ ...formCat, nombre: e.target.value })}
              />
            </div>
            <div>
              <Label htmlFor="tipo-cat">Tipo</Label>
              <select
                id="tipo-cat"
                data-testid="select-tipo-cat"
                value={formCat.tipo}
                onChange={(e) => setFormCat({ ...formCat, tipo: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1AA1D8]"
              >
                <option value="operacional">Operacional</option>
                <option value="capital">Capital</option>
                <option value="administrativo">Administrativo</option>
              </select>
            </div>

            {/* Gasto Mensual Máximo Estimado por Propiedad */}
            <div className="space-y-3 pt-3 border-t">
              <div>
                <Label className="text-sm font-bold text-[#0E3A53] flex items-center gap-1.5">
                  <DollarSign className="w-4 h-4 text-emerald-600" />
                  Gasto Mensual Máximo Estimado por Propiedad
                </Label>
                <p className="text-xs text-[#0E3A53]/65 mt-0.5">
                  Define el valor de gasto mensual estimado para cada propiedad (dejar vacío o 0 si no tiene tope).
                </p>
              </div>

              <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
                {propiedades.map(p => (
                  <div key={p.id_propiedad} className="flex items-center justify-between gap-3 p-2 bg-[#8FE0FF]/10 rounded-lg">
                    <span className="text-xs sm:text-sm font-medium text-[#0E3A53] truncate">{p.nombre}</span>
                    <div className="relative w-36 sm:w-44">
                      <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-[#0E3A53]/50 font-bold">$</span>
                      <Input
                        type="number"
                        min="0"
                        step="1000"
                        placeholder="0"
                        value={(formCat.gasto_mensual_maximo || {})[p.id_propiedad] ?? ''}
                        onChange={(e) => {
                          const val = parseFloat(e.target.value) || 0;
                          setFormCat({
                            ...formCat,
                            gasto_mensual_maximo: {
                              ...(formCat.gasto_mensual_maximo || {}),
                              [p.id_propiedad]: val
                            }
                          });
                        }}
                        className="pl-6 h-8 text-right text-xs sm:text-sm font-bold"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalCatAbierto(false)} data-testid="cancel-cat-btn">Cancelar</Button>
            <Button onClick={guardarCategoria} data-testid="save-cat-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Rápido: Gasto Mensual Máximo Estimado */}
      <Dialog open={modalPresupuestoAbierto} onOpenChange={setModalPresupuestoAbierto}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold text-[#0E3A53] flex items-center gap-2">
              <DollarSign className="w-5 h-5 text-emerald-600" />
              Límite Mensual Estimado
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="p-3 bg-[#8FE0FF]/15 rounded-lg">
              <p className="text-xs text-[#0E3A53]/70 font-medium">Categoría:</p>
              <p className="text-base font-bold text-[#0E3A53]">{catPresupuesto?.nombre}</p>
              <p className="text-xs text-[#0E3A53]/70 font-medium mt-1.5">Propiedad configurada:</p>
              <p className="text-sm font-bold text-[#1AA1D8]">{propiedadSeleccionada?.nombre}</p>
            </div>

            <div>
              <Label htmlFor="monto-presupuesto" className="text-sm text-[#0E3A53] font-semibold">
                Valor de gasto mensual máximo estimado ($)
              </Label>
              <div className="relative mt-1.5">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm font-bold text-[#0E3A53]/50">$</span>
                <Input
                  id="monto-presupuesto"
                  type="number"
                  min="0"
                  step="1000"
                  value={montoPresupuestoTemp}
                  onChange={(e) => setMontoPresupuestoTemp(e.target.value)}
                  placeholder="Ej: 150000 (0 para sin límite)"
                  className="pl-7 text-base font-bold text-[#0E3A53]"
                  autoFocus
                />
              </div>
              <p className="text-xs text-[#0E3A53]/60 mt-1.5">
                Si la suma de gastos de esta categoría en el mes supera este valor, se mostrará un ícono de alerta en la sección Distribución de Gastos del Dashboard y en el Resumen por Categoría.
              </p>
            </div>
          </div>
          <div className="flex gap-2 justify-end pt-3 border-t">
            <Button variant="outline" onClick={() => setModalPresupuestoAbierto(false)}>
              Cancelar
            </Button>
            <Button
              onClick={guardarPresupuestoPropiedad}
              className="bg-gradient-to-r from-emerald-600 to-[#0E3A53] text-white"
            >
              Guardar Límite
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Proveedor */}
      <Dialog open={modalProvAbierto} onOpenChange={setModalProvAbierto}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Proveedor' : 'Nuevo Proveedor'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre-prov">Nombre</Label>
              <Input
                id="nombre-prov"
                data-testid="input-nombre-prov"
                value={formProv.nombre}
                onChange={(e) => setFormProv({ ...formProv, nombre: e.target.value })}
              />
            </div>
            <div>
              <Label htmlFor="categoria-prov">Categoría</Label>
              <select
                id="categoria-prov"
                data-testid="select-categoria-prov"
                value={formProv.categoria_id}
                onChange={(e) => setFormProv({ ...formProv, categoria_id: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1AA1D8]"
              >
                <option value="">Seleccione una categoría</option>
                {categorias.map(cat => (
                  <option key={cat.id_categoria} value={cat.id_categoria}>
                    {cat.nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalProvAbierto(false)} data-testid="cancel-prov-btn">Cancelar</Button>
            <Button onClick={guardarProveedorModal} data-testid="save-prov-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Fusión de Proveedores */}
      <Dialog open={modalFusionAbierto} onOpenChange={setModalFusionAbierto}>
        <DialogContent className="max-w-2xl bg-white text-[#0E3A53] p-6 rounded-2xl shadow-2xl border border-[#8FE0FF]/30">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53] flex items-center gap-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              <GitMerge className="w-6 h-6 text-[#1AA1D8]" />
              Fusionar Proveedores Duplicados
            </DialogTitle>
          </DialogHeader>

          <p className="text-sm text-[#0E3A53]/70 -mt-2">
            Reasigna todos los gastos históricos y registros de un proveedor duplicado al proveedor principal que elijas conservar. El proveedor duplicado será eliminado de forma segura.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 relative">
            {/* Botón central flotante para intercambiar (visible en desktop) */}
            <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
              <button
                type="button"
                onClick={intercambiarSeleccionFusion}
                className="p-2.5 rounded-full bg-white shadow-lg border border-[#8FE0FF] hover:bg-[#8FE0FF]/20 text-[#1AA1D8] transition-all hover:scale-110"
                title="Invertir selección (Conservar ⇄ Duplicado)"
              >
                <ArrowRightLeft className="w-5 h-5" />
              </button>
            </div>

            {/* Tarjeta 1: Proveedor a CONSERVAR (Destino) */}
            <div className="bg-emerald-50/70 border-2 border-emerald-200/80 rounded-xl p-4 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold uppercase tracking-wider text-emerald-800 bg-emerald-100 px-2.5 py-0.5 rounded-full flex items-center gap-1">
                  <Check className="w-3.5 h-3.5 text-emerald-700" />
                  Proveedor a Conservar
                </span>
                <span className="text-xs text-emerald-600 font-medium">Destino Principal</span>
              </div>

              <div>
                <Label htmlFor="select-prov-destino" className="text-xs font-semibold text-emerald-950">
                  Selecciona el que SE QUEDA:
                </Label>
                <select
                  id="select-prov-destino"
                  value={proveedorDestinoId}
                  onChange={(e) => setProveedorDestinoId(e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-emerald-300 rounded-lg bg-white text-sm text-[#0E3A53] focus:outline-none focus:ring-2 focus:ring-emerald-500 font-medium"
                >
                  <option value="">-- Seleccionar proveedor principal --</option>
                  {proveedores
                    .filter(p => p.id_proveedor !== proveedorOrigenId)
                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                    .map(p => (
                      <option key={p.id_proveedor} value={p.id_proveedor}>
                        {p.nombre} ({p.gastos_count || 0} gastos)
                      </option>
                    ))}
                </select>
              </div>

              {proveedorDestinoId && (() => {
                const p = proveedores.find(x => x.id_proveedor === proveedorDestinoId);
                const cat = categorias.find(c => c.id_categoria === p?.categoria_id);
                return p ? (
                  <div className="bg-white/80 rounded-lg p-3 border border-emerald-200 text-xs space-y-1">
                    <p className="font-bold text-sm text-emerald-950">{p.nombre}</p>
                    <p className="text-emerald-800">
                      Categoría: <span className="font-medium">{cat?.nombre || 'Sin categoría'}</span>
                    </p>
                    <p className="text-emerald-800">
                      Gastos actuales: <span className="font-bold text-emerald-700">{p.gastos_count || 0}</span>
                    </p>
                  </div>
                ) : null;
              })()}
            </div>

            {/* Tarjeta 2: Proveedor DUPLICADO (Origen a eliminar) */}
            <div className="bg-amber-50/70 border-2 border-amber-200/80 rounded-xl p-4 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold uppercase tracking-wider text-amber-800 bg-amber-100 px-2.5 py-0.5 rounded-full flex items-center gap-1">
                  <Trash2 className="w-3.5 h-3.5 text-amber-700" />
                  Duplicado a Eliminar
                </span>
                <span className="text-xs text-amber-600 font-medium">Origen</span>
              </div>

              <div>
                <Label htmlFor="select-prov-origen" className="text-xs font-semibold text-amber-950">
                  Selecciona el que SE FUSIONA:
                </Label>
                <select
                  id="select-prov-origen"
                  value={proveedorOrigenId}
                  onChange={(e) => setProveedorOrigenId(e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-amber-300 rounded-lg bg-white text-sm text-[#0E3A53] focus:outline-none focus:ring-2 focus:ring-amber-500 font-medium"
                >
                  <option value="">-- Seleccionar duplicado a fusionar --</option>
                  {proveedores
                    .filter(p => p.id_proveedor !== proveedorDestinoId)
                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                    .map(p => (
                      <option key={p.id_proveedor} value={p.id_proveedor}>
                        {p.nombre} ({p.gastos_count || 0} gastos)
                      </option>
                    ))}
                </select>
              </div>

              {proveedorOrigenId && (() => {
                const p = proveedores.find(x => x.id_proveedor === proveedorOrigenId);
                const cat = categorias.find(c => c.id_categoria === p?.categoria_id);
                return p ? (
                  <div className="bg-white/80 rounded-lg p-3 border border-amber-200 text-xs space-y-1">
                    <p className="font-bold text-sm text-amber-950">{p.nombre}</p>
                    <p className="text-amber-800">
                      Categoría: <span className="font-medium">{cat?.nombre || 'Sin categoría'}</span>
                    </p>
                    <p className="text-amber-800">
                      Gastos a transferir: <span className="font-bold text-red-600">{p.gastos_count || 0}</span>
                    </p>
                  </div>
                ) : null;
              })()}
            </div>
          </div>

          {/* Botón de intercambio en móvil */}
          <div className="flex md:hidden justify-center my-1">
            <button
              type="button"
              onClick={intercambiarSeleccionFusion}
              className="px-3 py-1.5 rounded-lg bg-white shadow border border-[#8FE0FF] text-xs font-semibold text-[#1AA1D8] flex items-center gap-1.5"
            >
              <ArrowRightLeft className="w-4 h-4" />
              Invertir selección
            </button>
          </div>

          {/* Advertencia / Resumen del resultado */}
          {proveedorDestinoId && proveedorOrigenId && (
            <div className="bg-[#8FE0FF]/15 border border-[#8FE0FF]/50 rounded-xl p-3.5 flex items-start gap-3 mt-2 text-xs text-[#0E3A53]">
              <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className="font-semibold text-sm">Resumen de la Fusión:</p>
                <p>
                  • Todos los gastos de <strong className="text-amber-700">"{proveedores.find(p => p.id_proveedor === proveedorOrigenId)?.nombre}"</strong> ({proveedores.find(p => p.id_proveedor === proveedorOrigenId)?.gastos_count || 0} registros) pasarán a ser de <strong className="text-emerald-700">"{proveedores.find(p => p.id_proveedor === proveedorDestinoId)?.nombre}"</strong>.
                </p>
                <p>
                  • El proveedor <strong className="text-amber-700">"{proveedores.find(p => p.id_proveedor === proveedorOrigenId)?.nombre}"</strong> será eliminado permanentemente.
                </p>
                <p>
                  • Las categorías asociadas de ambos proveedores se combinarán en el proveedor principal.
                </p>
              </div>
            </div>
          )}

          <div className="flex gap-3 justify-end mt-4">
            <Button
              variant="outline"
              onClick={() => setModalFusionAbierto(false)}
              disabled={cargandoFusion}
            >
              Cancelar
            </Button>
            <Button
              onClick={ejecutarFusionProveedores}
              disabled={!proveedorDestinoId || !proveedorOrigenId || cargandoFusion}
              className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53] text-white flex items-center gap-2"
            >
              <GitMerge className="w-4 h-4" />
              {cargandoFusion ? 'Fusionando...' : 'Confirmar y Fusionar'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Medio de Pago */}
      <Dialog open={modalMedioPagoAbierto} onOpenChange={setModalMedioPagoAbierto}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Medio de Pago' : 'Nuevo Medio de Pago'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre-medio-pago">Nombre</Label>
              <Input
                id="nombre-medio-pago"
                data-testid="input-nombre-medio-pago"
                value={formMedioPago.nombre}
                onChange={(e) => setFormMedioPago({ ...formMedioPago, nombre: e.target.value })}
                placeholder="Ej: Transferencia, Efectivo, Tarjeta de Crédito"
              />
            </div>
            <div className="flex items-center gap-3">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={formMedioPago.activo}
                  onChange={(e) => setFormMedioPago({ ...formMedioPago, activo: e.target.checked })}
                  className="sr-only peer"
                  data-testid="checkbox-activo-medio-pago"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-cyan-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">
                  {formMedioPago.activo ? 'Activo' : 'Inactivo'}
                </span>
              </label>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalMedioPagoAbierto(false)} data-testid="cancel-medio-pago-btn">Cancelar</Button>
            <Button onClick={guardarMedioPago} data-testid="save-medio-pago-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Usuario */}
      <Dialog open={modalUsuarioAbierto} onOpenChange={setModalUsuarioAbierto}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              {editando ? 'Editar Usuario' : 'Nuevo Usuario'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email-usuario">Email</Label>
              <Input
                id="email-usuario"
                data-testid="input-email-usuario"
                type="email"
                value={formUsuario.email}
                onChange={(e) => setFormUsuario({ ...formUsuario, email: e.target.value })}
                placeholder="usuario@email.com"
              />
            </div>
            <div>
              <Label htmlFor="password-usuario">
                {editando ? 'Nueva Contraseña (dejar vacío para mantener)' : 'Contraseña'}
              </Label>
              <div className="relative">
                <Input
                  id="password-usuario"
                  data-testid="input-password-usuario"
                  type={mostrarPassword ? 'text' : 'password'}
                  value={formUsuario.password}
                  onChange={(e) => setFormUsuario({ ...formUsuario, password: e.target.value })}
                  placeholder={editando ? '••••••••' : 'Contraseña segura'}
                />
                <button
                  type="button"
                  onClick={() => setMostrarPassword(!mostrarPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                >
                  {mostrarPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={formUsuario.is_admin}
                  onChange={(e) => setFormUsuario({ ...formUsuario, is_admin: e.target.checked })}
                  className="sr-only peer"
                  data-testid="checkbox-admin-usuario"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-cyan-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">Administrador</span>
              </label>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={formUsuario.activo}
                  onChange={(e) => setFormUsuario({ ...formUsuario, activo: e.target.checked })}
                  className="sr-only peer"
                  data-testid="checkbox-activo-usuario"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
                <span className="ml-3 text-sm font-medium text-gray-700">Activo</span>
              </label>
            </div>
            <div>
              <Label>Propiedades Asignadas</Label>
              <p className="text-xs text-[#0E3A53]/60 mb-2">
                {formUsuario.is_admin 
                  ? 'Los administradores tienen acceso a todas las propiedades' 
                  : 'Selecciona las propiedades que este usuario podrá ver y gestionar'}
              </p>
              <div className="space-y-2 max-h-48 overflow-y-auto p-2 border rounded-lg bg-white">
                {todasLasPropiedades.map(prop => (
                  <label 
                    key={prop.id_propiedad} 
                    className={`flex items-center gap-3 p-2 rounded-lg cursor-pointer transition-colors ${
                      formUsuario.propiedades_asignadas?.includes(prop.id_propiedad) 
                        ? 'bg-[#8FE0FF]/30' 
                        : 'hover:bg-[#8FE0FF]/10'
                    } ${formUsuario.is_admin ? 'opacity-50' : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={formUsuario.propiedades_asignadas?.includes(prop.id_propiedad) || false}
                      onChange={() => togglePropiedadAsignada(prop.id_propiedad)}
                      disabled={formUsuario.is_admin}
                      className="w-4 h-4 text-cyan-600 border-gray-300 rounded focus:ring-cyan-500"
                    />
                    <span className="text-sm text-[#0E3A53]">{prop.nombre}</span>
                  </label>
                ))}
                {todasLasPropiedades.length === 0 && (
                  <p className="text-center text-[#0E3A53]/50 py-4 text-sm">No hay propiedades disponibles</p>
                )}
              </div>
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-4">
            <Button variant="outline" onClick={() => setModalUsuarioAbierto(false)} data-testid="cancel-usuario-btn">Cancelar</Button>
            <Button onClick={guardarUsuario} data-testid="save-usuario-btn" className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]">Guardar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Configuracion;
